import * as React from "react";

const SvgFront = React.forwardRef((props, ref) => {
  return (
    <svg
      id="front_svg__front_animated"
      data-name="front animated"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1920 2350"
      {...props}
			ref={ref}
    >
      <defs>
        <linearGradient
          id="front_svg__linear-gradient"
          x1="0%"
          y1="0%"
          x2="100%"
          y2="0%"
        >
          <stop offset="0%" stopColor="#76c6f5" />
          <stop offset="100%" stopColor="#00fcac" />
        </linearGradient>
        <linearGradient
          id="front_svg__linear-gradient-2"
          x1={358.55}
          y1={2266.72}
          x2={431.63}
          y2={2266.72}
          xlinkHref="#front_svg__linear-gradient"
        />
        <linearGradient
          id="front_svg__linear-gradient-4865"
          x1={1309.84}
          y1={236.82}
          x2={1309.84}
          y2={356.42}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#76c6f5" />
          <stop offset={0.38} stopColor="#4cd9db" />
          <stop offset={1} stopColor="#00fcac" />
        </linearGradient>
        <style>
          {
            ".front_svg__yellow-star{transform-origin:&quot;center center&quot;}.front_svg__cls-2435,.front_svg__cls-4880,.front_svg__cls-4882{fill:#fff}.front_svg__cls-2434,.front_svg__cls-2435,.front_svg__cls-4870,.front_svg__cls-4874{stroke:#000}.front_svg__cls-2437,.front_svg__cls-4872,.front_svg__cls-4878,.front_svg__cls-4879,.front_svg__cls-4882,.front_svg__cls-4884,.front_svg__cls-4886{stroke-miterlimit:10}.front_svg__cls-2434,.front_svg__cls-2435,.front_svg__cls-2436,.front_svg__cls-2437,.front_svg__cls-4870,.front_svg__cls-4872,.front_svg__cls-4874,.front_svg__cls-4878,.front_svg__cls-4879{stroke-width:3.15px}.front_svg__circle{fill:url(#front_svg__linear-gradient)}.front_svg__cls-4870,.front_svg__cls-4878{fill:none}.front_svg__cls-4872,.front_svg__cls-4886{fill:#c581ff}.front_svg__cls-4874{fill:#dfdfdf}.front_svg__cls-4881{fill-rule:evenodd}.front_svg__cls-4882,.front_svg__cls-4884{stroke:#12122e}.front_svg__cls-4882,.front_svg__cls-4884,.front_svg__cls-4886{stroke-width:1.57px}.front_svg__cls-4885{fill:#b0dbf4}"
          }
        </style>
      </defs>
      <path
        id="front_svg__white-blob"
        d="M685.23 1606.93c-1.78-.43-3.57-.83-5.37-1.18a120.68 120.68 0 00-15.87-2.33 115.9 115.9 0 00-12.11-.63c-1.79 0-3.41 0-4.72.1a123.7 123.7 0 00-15.23 1.29 125.16 125.16 0 00-14.14 2.68 123.34 123.34 0 00-12.78 3.71q-5.68 1.88-11.26 4.33c-3.33 1.4-6.6 2.93-9.76 4.6l-1.42-1.71c-2.3-2.82-4.7-5.53-7.2-8.1q-3.12-3.35-6.47-6.43c-2.57-2.46-5.29-4.84-8.13-7.11s-5.63-4.51-8.56-6.55q-3.71-2.7-7.59-5.1c-3.09-2-6.32-3.86-9.65-5.6s-6.7-3.48-10.13-5c-2.84-1.3-5.73-2.5-8.64-3.57a121.41 121.41 0 00-11.7-3.86c-3.86-1.15-7.82-2.11-11.82-2.88a122.31 122.31 0 00-12.46-2 118.09 118.09 0 00-13.38-1c-1.25-.05-2.64-.08-4.19-.08-3.2 0-6.47.13-9.74.4a120.94 120.94 0 00-13.75 1.59c-3.78.59-7.53 1.36-11.21 2.29a121.92 121.92 0 00-16.46 5.11c-3.7 1.36-7.35 2.9-10.91 4.62a121.06 121.06 0 00-12 6.39 119.64 119.64 0 00-10.79 7c-3.24 2.27-6.4 4.71-9.45 7.32-2.91 2.38-5.72 4.92-8.41 7.57-2.18 2.07-4.29 4.21-6.29 6.42-2.3 2.42-4.49 5-6.64 7.65-2 2.39-3.9 4.81-5.67 7.27a93.125 93.125 0 00-4 5.74c-1.14 1.64-2.24 3.31-3.3 5q-1.93 2.94-3.67 5.94c-.82 1.35-1.62 2.72-2.38 4.11q-1 1.8-2 3.63c-.71 1.25-1.39 2.51-2.06 3.78s-1.33 2.49-2 3.74-1.27 2.44-1.87 3.67c-.9 1.72-1.74 3.45-2.54 5.19-.62 1.28-1.22 2.56-1.8 3.86s-1.18 2.58-1.74 3.89-1.13 2.56-1.67 3.86-1.08 2.54-1.6 3.83-1.06 2.58-1.56 3.88-1 2.54-1.49 3.82c-.7 1.79-1.37 3.6-2 5.42q-.72 2-1.38 4c-.46 1.31-.9 2.63-1.31 4s-.84 2.54-1.22 3.82-.85 2.7-1.24 4.06-.8 2.65-1.16 4-.73 2.53-1.06 3.8q-.81 2.83-1.48 5.69c-.34 1.33-.66 2.66-1 4s-.63 2.66-.9 4-.59 2.64-.85 4-.57 2.68-.82 4-.52 2.67-.76 4-.47 2.56-.68 3.85q-.54 2.93-.94 5.83c-.22 1.4-.41 2.79-.58 4.18s-.36 2.65-.51 4-.33 2.7-.46 4-.31 2.72-.43 4.09-.26 2.66-.36 4-.24 2.69-.32 4-.2 2.61-.27 3.93c-.15 2-.25 3.91-.31 5.85-.06 1.27-.12 2.68-.14 4.21-.06 1.2-.09 2.59-.1 4.11v8.33c0 1.39 0 2.67.07 3.8 0 .82 0 1.6.05 2.33a121.39 121.39 0 0011.73 242.22h.78a121.28 121.28 0 00-21.52 177.65 120.8 120.8 0 00-13.39 50.5 121.4 121.4 0 00127.55 200.78q4.58-1.5 9-3.36c3.44-1.26 6.83-2.68 10.14-4.24q4.44-1.86 8.72-4.07 4.38-2 8.59-4.36 4.77-2.4 9.35-5.24 4-2.21 7.79-4.73 4.5-2.67 8.73-5.71 3.9-2.57 7.61-5.42 3.71-2.61 7.2-5.46c2.81-2.1 5.54-4.33 8.16-6.67q3.84-3.06 7.45-6.44 2.87-2.51 5.57-5.19 3.63-3.27 7-6.82 2.37-2.3 4.62-4.73c1.53-.29 3.06-.61 4.58-1s3.17-.67 4.74-1 3.37-.75 5-1.18 3.14-.75 4.69-1.17 3.13-.8 4.7-1.24 3.24-.88 4.87-1.37 3-.86 4.53-1.34 3-.89 4.54-1.38 3-.93 4.53-1.44 2.93-.93 4.38-1.43 3.05-1 4.54-1.55 3.12-1.07 4.65-1.65c1.31-.46 2.63-.94 3.94-1.45 1.57-.56 3.13-1.16 4.71-1.8 1.41-.52 2.81-1.08 4.21-1.66s2.8-1.1 4.18-1.7 2.83-1.14 4.23-1.75 2.78-1.16 4.15-1.78 2.7-1.15 4-1.76 2.78-1.21 4.13-1.85 2.83-1.26 4.21-1.93 2.63-1.21 3.93-1.85 2.5-1.18 3.73-1.8c1.38-.65 2.74-1.33 4.11-2s2.65-1.31 4-2 2.5-1.27 3.74-1.94 2.45-1.26 3.66-1.92 2.4-1.26 3.58-1.92 2.37-1.25 3.53-1.9 2.34-1.26 3.49-1.92 2.35-1.28 3.5-1.94 2.31-1.28 3.44-1.94l1.56-.87q2.28 2.4 4.69 4.7c1.88 1.9 3.81 3.72 5.77 5.47s4.16 3.72 6.37 5.51 4.4 3.65 6.67 5.33c2 1.53 4 3 6 4.42q3.32 2.43 6.8 4.63 3.16 2.13 6.41 4c2.35 1.45 4.76 2.83 7.27 4.15s4.8 2.63 7.23 3.8q3.31 1.71 6.75 3.22 3.64 1.72 7.44 3.21c2.5 1.08 5 2.06 7.52 2.94s5 1.82 7.65 2.61 5.21 1.67 7.82 2.36 5 1.39 7.56 2 5.37 1.26 8.12 1.76 5.61 1.1 8.4 1.5 5.49.81 8.32 1.08 5.44.6 8.15.75c3.11.28 6.16.43 9.2.46 2.49.1 5.67.11 8.15 0 3.13 0 6.24-.14 9.42-.4 2.91-.16 5.84-.42 8.77-.79s5.79-.65 8.61-1.13c3.2-.46 6.39-1.05 9.62-1.79 3-.57 5.87-1.25 8.73-2 2.7-.66 5.39-1.43 8.11-2.31 2.48-.72 4.93-1.51 7.33-2.37s4.75-1.65 7.07-2.58 4.72-1.84 7.06-2.88 4.87-2.08 7.22-3.23c2.18-1 4.36-2.07 6.5-3.22s4.32-2.23 6.43-3.45c2.27-1.22 4.45-2.48 6.58-3.8.88-.52 1.75-1.05 2.62-1.59 1.22.25 2.46.48 3.69.69 3 .58 6 1.06 9 1.42 2.66.38 5.36.67 8.07.88 3.13.33 6.19.53 9.24.61 1.78.1 3.85.17 6.13.17h1.84c2.55 0 5.34 0 8.09-.19s5.74-.3 8.68-.61c2.46-.19 4.91-.46 7.34-.79q2.91-.33 5.79-.79l13.78-2.64c1.13-.26 2.24-.53 3.35-.81s2.37-.58 3.56-.89c1.87.6 3.75 1.17 5.64 1.68 2.86.86 5.76 1.61 8.66 2.26s5.88 1.34 8.86 1.84 6.09 1.09 9.15 1.45 5.93.75 8.93 1c3.29.34 6.51.53 9.72.59 2.94.14 6 .16 8.48.08h.14c3.25 0 6.47-.13 9.76-.4 2.82-.16 5.66-.41 8.5-.77 3-.3 6-.7 9-1.21s5.66-1 8.49-1.6 5.83-1.23 8.65-2 5.5-1.47 8.27-2.38 5.41-1.68 8-2.65 5.2-1.9 7.78-3 4.95-2 7.36-3.17 4.88-2.25 7.26-3.49 4.51-2.31 6.73-3.57c2.37-1.27 4.65-2.58 6.86-3.95s4.27-2.63 6.4-4.08q3-1.9 5.86-4t5.62-4.08l1.77-1.32q2.36 1.36 4.79 2.63c1.63.91 3.28 1.77 4.93 2.59q3 1.59 6.15 3 2.55 1.23 5.18 2.34c1.65.74 3.32 1.45 5 2.13s3.43 1.42 5.15 2.06q3.16 1.27 6.36 2.35c1.75.64 3.53 1.23 5.33 1.79s3.37 1.1 5.07 1.59c1 .33 2.07.64 3.1.94l43.8 8.24c1.22.12 2.43.22 3.65.3 1.79.17 3.59.29 5.37.38 2.38.17 4.77.27 7.15.3 1.61.06 3.54.09 5.38.08s3.7 0 5.25 0a107 107 0 005.8-.18c2.33-.07 4.67-.22 7-.43 1.75-.12 3.49-.27 5.24-.46s3.56-.34 5.33-.57 3.76-.44 5.62-.72c2.32-.3 4.66-.67 7-1.12q2.7-.45 5.37-1t5.37-1.13c1.89-.4 3.77-.84 5.62-1.32l1.8-.44 1.44.32c3.29.8 6.62 1.47 10 2q4.57.84 9.26 1.34c3.09.42 6.2.72 9.3.89 3.34.29 6.61.44 9.88.45 2.58.08 5.93.06 8.49-.05 3.13 0 6.27-.21 9.49-.51 2.88-.19 5.76-.47 8.61-.86s5.56-.69 8.28-1.17 5.66-.95 8.5-1.59 5.73-1.2 8.52-2q3.81-.91 7.62-2.1c2.69-.75 5.35-1.59 8-2.52q3.55-1.14 7-2.49c1.28-.46 2.56-1 3.83-1.46a121.48 121.48 0 00138.72 9.58l.75.61q3.3 2.83 6.73 5.41c2.09 1.64 4.25 3.23 6.47 4.74 2.32 1.69 4.71 3.3 7.14 4.81 2.25 1.49 4.56 2.91 6.89 4.24s4.88 2.83 7.41 4.12 4.9 2.59 7.38 3.74 5.19 2.44 7.91 3.54 5.47 2.31 8.23 3.29c2.54 1 5.14 1.87 7.79 2.69s5.57 1.79 8.38 2.52 5.53 1.49 8.34 2.09 5.76 1.28 8.67 1.77 5.86 1 8.81 1.37 5.81.73 8.75.94c3.3.34 6.52.54 9.72.6 2.56.12 6 .17 8.69.09h.09c3.25 0 6.49-.14 9.8-.41q4.45-.26 8.92-.82c3-.3 6-.71 8.89-1.22s5.9-1 8.85-1.67 5.75-1.23 8.54-2 5.72-1.53 8.6-2.48 5.7-1.78 8.45-2.81 5.28-2 7.91-3.1 5.35-2.22 7.92-3.46 4.94-2.33 7.37-3.63c2.58-1.29 5.12-2.67 7.6-4.14s4.68-2.71 7-4.18 4.79-3.05 7.12-4.71 4.49-3.11 6.62-4.76c2.3-1.69 4.55-3.48 6.78-5.38s4.49-3.72 6.59-5.66c2-1.76 4-3.61 5.86-5.53q3.13-3 6-6.16c1.87-1.95 3.7-4 5.46-6.08q2.91-3.28 5.59-6.79c1.71-2.12 3.36-4.3 4.92-6.52q2.67-3.6 5.09-7.42 2.35-3.49 4.44-7.1c1.55-2.56 3-5.19 4.41-7.9 1.39-2.52 2.68-5.07 3.87-7.63 1.35-2.76 2.6-5.59 3.77-8.52 1.2-2.77 2.29-5.54 3.26-8.34 1.11-3 2.1-6 3-9.09a121.46 121.46 0 00-160.31-149.8c-.83-1.61-1.68-3.21-2.58-4.8q-2.56-4.85-5.54-9.41a119.25 119.25 0 00-6.8-9.94 123.08 123.08 0 00-7.79-9.68 121.81 121.81 0 00-8.6-9.15 123.15 123.15 0 00-10-9.09 125.08 125.08 0 00-11.44-8.68 158.55 158.55 0 00-24.46-13.82 123.38 123.38 0 00-12.56-5.06 125 125 0 00-13-4 122.77 122.77 0 00-12.5-2.7c-3.89-.74-7.84-1.29-11.81-1.64a120.28 120.28 0 00-12.59-.85c-3.19-.14-7.18-.14-11.08.06a117.11 117.11 0 00-11.71.89h0q-1.44-1.42-2.91-2.79l-.54-.52c.86-.48 1.71-1 2.58-1.48s1.66-1 2.51-1.46 1.75-1 2.63-1.54 1.74-1 2.62-1.56l2.41-1.44c1.38-.81 2.74-1.64 4.09-2.51.77-.46 1.53-.93 2.27-1.41.89-.54 1.76-1.08 2.61-1.64s1.68-1 2.5-1.58 1.77-1.12 2.63-1.69 1.67-1.07 2.48-1.61 1.67-1.08 2.49-1.64 1.71-1.11 2.55-1.68 1.68-1.12 2.51-1.69 1.65-1.1 2.46-1.67 1.7-1.14 2.54-1.74 1.69-1.15 2.52-1.74 1.61-1.12 2.42-1.69l2.46-1.74c.83-.58 1.66-1.17 2.49-1.78s1.59-1.14 2.39-1.73l2.49-1.81c.77-.56 1.54-1.13 2.32-1.72 1.26-.91 2.52-1.85 3.76-2.82l2.2-1.68c.84-.63 1.67-1.27 2.48-1.91s1.58-1.22 2.35-1.83 1.62-1.26 2.41-1.9 1.6-1.26 2.37-1.89 1.56-1.23 2.32-1.86 1.6-1.28 2.38-1.94 1.59-1.28 2.37-1.94 1.52-1.24 2.26-1.88 1.6-1.32 2.39-2 1.55-1.29 2.31-2 1.49-1.25 2.22-1.89 1.57-1.34 2.35-2 1.56-1.34 2.33-2 1.52-1.32 2.28-2 1.37-1.2 2-1.82c1.21-1.06 2.41-2.14 3.58-3.24.72-.65 1.42-1.3 2.11-2s1.51-1.39 2.24-2.09 1.47-1.36 2.18-2 1.5-1.41 2.23-2.12 1.49-1.41 2.22-2.13a121.38 121.38 0 10-168.75-174.5l-1.19 1.13-1.35 1.27-1.26 1.18-1.36 1.25c-.56.5-1.15 1-1.78 1.63l-.21.2c-.64.56-1.23 1.09-1.78 1.59l-1.37 1.22-1.31 1.16c-.43.36-.86.74-1.29 1.12s-.94.8-1.4 1.21-1 .81-1.46 1.23l-1.34 1.13-1.34 1.11c-.49.39-1 .78-1.44 1.18s-.91.73-1.36 1.1l-1.49 1.19c-.45.36-.91.71-1.35 1.07l-1.45 1.13-1.48 1.15-1.37 1c-.6.45-1.24.93-1.91 1.45l-.22.17c-.72.51-1.38 1-2 1.48l-1.41 1-1.52 1.11-1.47 1.06-1.48 1.05q-.72.49-1.44 1t-1.56 1.08l-1.52 1-1.48 1c-.5.33-1 .66-1.49 1l-1.48 1c-.55.35-1.09.71-1.63 1.07s-1 .65-1.52 1l-1.49 1-1.55 1c-.51.31-1 .64-1.6 1s-1.24.75-1.91 1.18l-.27.16c-.78.46-1.51.9-2.18 1.32s-1.08.64-1.58.94l-1.53.91-1.64 1c-.52.29-1 .59-1.55.9l-1.65.93-1.52.86-1.64.91-1.62.89-1.61.87c-.54.28-1.07.57-1.6.86l-1.67.87-1.63.85-1.58.81c-.53.26-1.09.54-1.68.85s-1.11.54-1.7.85-1.06.51-1.63.8-1.36.65-2.1 1l-.32.16c-.78.36-1.51.71-2.19 1l-1.64.77c-.6.28-1.17.54-1.7.8l-1.67.76-1.67.76-1.62.72c-.6.26-1.21.52-1.81.8s-1.1.46-1.64.71l-1.72.73-1.66.7c-.58.23-1.15.46-1.71.7l-1.75.71-1.68.67-1.7.67-1.8.7-1.65.63-1.8.68a108 108 0 00-2.23.82l-.2.08c-.92.32-1.74.62-2.47.89l-1.26.45-1.64.58-1.62.56-1.51.52c-.54.17-1 .34-1.52.51s-1.06.34-1.59.52l-1.56.51-1.65.52-1.49.47-1.58.49-1.63.5-1.6.47-1.51.44-1.68.49-1.5.42-1.65.46-1.56.42-1.57.42-1.88.5-2.07.53-1.55.39-1.66.41c-.58.13-1.13.26-1.62.39l-1.57.37-1.59.37-1.63.37-1.58.35-1.68.36-1.52.32-1.64.34-1.63.33-1.58.31-1.67.32-1 .18v-.32-1.26a120.52 120.52 0 00-11.1-50.69 121.42 121.42 0 00-44.56-234.36c-1.55 0-2.95 0-4.21.09-.89 0-1.73 0-2.51.07l-2.32.07-2.38.08c-.84 0-1.64 0-2.38.07s-1.64 0-2.39.07l-2.38.07c-.85 0-1.64 0-2.38.08s-1.69 0-2.43.07-1.61 0-2.33.07c-.88 0-1.7 0-2.47.08s-1.6 0-2.32.07h-.33a121.84 121.84 0 00-215.7-44.25c-.59.75-1.17 1.51-1.75 2.29l-1.66 2.17-1.57 2.06c-.56.73-1.13 1.47-1.69 2.23s-1.1 1.44-1.65 2.18-1.11 1.44-1.65 2.18-1.16 1.5-1.73 2.28-1.08 1.42-1.62 2.15-1.09 1.43-1.63 2.16c-.8 1-1.6 2.1-2.37 3.18-.55.71-1.08 1.43-1.59 2.14s-1.16 1.55-1.72 2.32-1.12 1.5-1.66 2.25-1.22 1.64-1.8 2.46-1.15 1.55-1.7 2.33-1.17 1.58-1.73 2.38-1.2 1.65-1.79 2.48-1.14 1.58-1.7 2.37-1.2 1.68-1.79 2.52-1.14 1.59-1.69 2.39-1.17 1.65-1.74 2.48-1.2 1.7-1.78 2.55l-.28.41h-.87l-2.39.07-2.38.08c-.85 0-1.64 0-2.39.07l-2.37.07c-.88 0-1.7 0-2.46.08s-1.6 0-2.32.07-1.64 0-2.39.07-1.64 0-2.38.07l-2.39.07c-.85 0-1.65 0-2.4.08s-1.63 0-2.37.07-1.64 0-2.38.07l-2.38.07-2.43.08c-.83 0-1.61 0-2.35.07s-1.69 0-2.45.07l-2.32.07-2.38.07-2.38.08c-.85 0-1.64 0-2.39.07s-1.65 0-2.4.07l-2.38.07-2.38.08c-.84 0-1.64 0-2.38.07l-2.46.07-2.31.07-2.39.08c-.85 0-1.64 0-2.38.07l-2.38.07-2.39.07c-.85 0-1.64 0-2.38.08s-1.65 0-2.39.07-1.68 0-2.42.07l-2.35.07-2.38.07-2.45.08-2.33.07-2.39.07c-.84 0-1.64 0-2.37.08s-1.65 0-2.39.07-1.63 0-2.38.07l-2.43.07c-.83 0-1.62 0-2.36.08s-1.63 0-2.37.07-1.64 0-2.39.07-1.55 0-2.26.07a120.73 120.73 0 00-71.15 24.36q-2.59-.81-5.21-1.5a120.88 120.88 0 00-11.56-2.65c-3.68-.74-7.4-1.31-11.13-1.71s-7.61-.8-11.36-.93c-1.67-.1-3.84-.19-6.32-.19h-3c-3.83 0-7.66.23-11.63.64-2.64.22-5.26.51-7.84.89-3.7.48-7.39 1.14-11.15 2q-5.24 1.07-10.3 2.57c-2.42.67-4.84 1.42-7.22 2.24l-1.9.64a121.62 121.62 0 00-15.19-8.12c-.51-.25-1-.48-1.55-.72zm1068.24 638.8zM327.36 1893.27z"
        strokeWidth={3.15}
        strokeMiterlimit={10}
        stroke="#000"
        fill="#fff"
      />
      <g id="front_svg__alten">
        <circle
          className="front_svg__circle"
          cx={391.96}
          cy={2265.66}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={395.09}
          cy={2266.72}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={398.22}
          cy={2267.7}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={401.37}
          cy={2268.6}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={404.54}
          cy={2269.44}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={407.71}
          cy={2270.2}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={410.89}
          cy={2270.89}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={414.08}
          cy={2271.52}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={417.28}
          cy={2272.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={420.49}
          cy={2272.56}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={423.71}
          cy={2272.98}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={426.94}
          cy={2273.33}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={430.17}
          cy={2273.62}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={433.41}
          cy={2273.85}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={436.65}
          cy={2274.01}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={439.9}
          cy={2274.11}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={443.15}
          cy={2274.15}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={446.4}
          cy={2274.13}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={449.66}
          cy={2274.06}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={452.92}
          cy={2273.92}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={456.18}
          cy={2273.73}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={459.45}
          cy={2273.49}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={462.71}
          cy={2273.19}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={465.97}
          cy={2272.83}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={469.24}
          cy={2272.43}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={472.5}
          cy={2271.97}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={475.76}
          cy={2271.46}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={479.01}
          cy={2270.9}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={482.27}
          cy={2270.3}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={485.52}
          cy={2269.65}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={488.76}
          cy={2268.95}
          r={36.54}
        />
        <circle className="front_svg__circle" cx={492} cy={2268.2} r={36.54} />
        <circle
          className="front_svg__circle"
          cx={495.23}
          cy={2267.41}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={498.46}
          cy={2266.58}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={501.68}
          cy={2265.71}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={504.89}
          cy={2264.79}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={508.1}
          cy={2263.84}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={511.29}
          cy={2262.84}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={514.48}
          cy={2261.81}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={517.66}
          cy={2260.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={520.82}
          cy={2259.63}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={523.97}
          cy={2258.49}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={527.12}
          cy={2257.32}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={530.25}
          cy={2256.11}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={533.36}
          cy={2254.87}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={536.46}
          cy={2253.6}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={539.55}
          cy={2252.3}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={542.63}
          cy={2250.97}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={545.68}
          cy={2249.61}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={548.72}
          cy={2248.22}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={551.75}
          cy={2246.81}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={554.76}
          cy={2245.38}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={557.74}
          cy={2243.92}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={560.71}
          cy={2242.43}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={563.66}
          cy={2240.93}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={566.59}
          cy={2239.4}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={569.51}
          cy={2237.86}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={572.42}
          cy={2236.3}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={575.32}
          cy={2234.72}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={578.21}
          cy={2233.12}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={581.09}
          cy={2231.51}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={583.97}
          cy={2229.88}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={586.83}
          cy={2228.23}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={589.69}
          cy={2226.58}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={592.54}
          cy={2224.91}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={595.39}
          cy={2223.23}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={598.23}
          cy={2221.54}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={601.06}
          cy={2219.84}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={603.89}
          cy={2218.13}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={606.72}
          cy={2216.41}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={609.54}
          cy={2214.69}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={612.36}
          cy={2212.96}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={615.17}
          cy={2211.22}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={617.99}
          cy={2209.48}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={620.79}
          cy={2207.73}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={623.6}
          cy={2205.98}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={626.41}
          cy={2204.23}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={629.22}
          cy={2202.48}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={632.02}
          cy={2200.73}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={634.83}
          cy={2198.98}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={637.63}
          cy={2197.23}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={640.37}
          cy={2195.53}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={643.29}
          cy={2193.71}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={646.15}
          cy={2191.94}
          r={36.54}
        />
        <circle className="front_svg__circle" cx={649} cy={2190.18} r={36.54} />
        <circle
          className="front_svg__circle"
          cx={651.86}
          cy={2188.43}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={654.73}
          cy={2186.68}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={657.59}
          cy={2184.94}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={660.46}
          cy={2183.21}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={663.34}
          cy={2181.48}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={666.22}
          cy={2179.77}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={669.11}
          cy={2178.07}
          r={36.54}
        />
        <circle className="front_svg__circle" cx={672} cy={2176.39} r={36.54} />
        <circle
          className="front_svg__circle"
          cx={674.9}
          cy={2174.71}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={677.81}
          cy={2173.05}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={680.73}
          cy={2171.41}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={683.65}
          cy={2169.78}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={686.58}
          cy={2168.17}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={689.53}
          cy={2166.57}
          r={36.54}
        />
        <circle className="front_svg__circle" cx={692.48} cy={2165} r={36.54} />
        <circle
          className="front_svg__circle"
          cx={695.44}
          cy={2163.44}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={698.41}
          cy={2161.91}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={701.4}
          cy={2160.39}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={704.39}
          cy={2158.9}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={707.4}
          cy={2157.44}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={710.42}
          cy={2155.99}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={713.45}
          cy={2154.58}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={716.5}
          cy={2153.18}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={719.56}
          cy={2151.82}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={722.64}
          cy={2150.48}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={725.74}
          cy={2149.18}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={728.87}
          cy={2147.91}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={732.01}
          cy={2146.67}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={735.18}
          cy={2145.47}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={738.37}
          cy={2144.3}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={741.58}
          cy={2143.18}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={744.8}
          cy={2142.09}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={748.05}
          cy={2141.04}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={751.3}
          cy={2140.03}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={754.57}
          cy={2139.06}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={757.86}
          cy={2138.13}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={761.16}
          cy={2137.25}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={764.47}
          cy={2136.41}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={767.78}
          cy={2135.61}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={771.11}
          cy={2134.86}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={774.45}
          cy={2134.16}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={777.79}
          cy={2133.51}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={781.14}
          cy={2132.9}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={784.49}
          cy={2132.35}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={787.85}
          cy={2131.84}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={791.21}
          cy={2131.39}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={794.57}
          cy={2130.99}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={797.94}
          cy={2130.64}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={801.3}
          cy={2130.35}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={804.66}
          cy={2130.11}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={808.02}
          cy={2129.93}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={811.37}
          cy={2129.8}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={814.72}
          cy={2129.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={818.07}
          cy={2129.73}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={821.41}
          cy={2129.78}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={824.74}
          cy={2129.9}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={828.06}
          cy={2130.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={831.37}
          cy={2130.31}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={834.67}
          cy={2130.62}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={837.96}
          cy={2130.98}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={841.23}
          cy={2131.42}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={844.49}
          cy={2131.92}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={847.74}
          cy={2132.48}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={850.97}
          cy={2133.12}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={854.18}
          cy={2133.82}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={857.37}
          cy={2134.6}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={860.55}
          cy={2135.45}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={863.7}
          cy={2136.36}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={866.83}
          cy={2137.36}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={869.94}
          cy={2138.42}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={873.03}
          cy={2139.57}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={876.09}
          cy={2140.78}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={879.12}
          cy={2142.08}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={882.13}
          cy={2143.45}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={885.11}
          cy={2144.9}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={888.06}
          cy={2146.43}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={890.98}
          cy={2148.05}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={893.87}
          cy={2149.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={890.76}
          cy={2148.84}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={887.64}
          cy={2147.95}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={884.52}
          cy={2147.05}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={881.39}
          cy={2146.17}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={878.25}
          cy={2145.29}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={875.11}
          cy={2144.43}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={871.97}
          cy={2143.58}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={868.81}
          cy={2142.75}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={865.65}
          cy={2141.94}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={862.49}
          cy={2141.15}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={859.33}
          cy={2140.39}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={856.15}
          cy={2139.65}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={852.98}
          cy={2138.95}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={849.8}
          cy={2138.27}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={846.62}
          cy={2137.63}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={843.43}
          cy={2137.03}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={840.24}
          cy={2136.47}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={837.05}
          cy={2135.95}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={833.86}
          cy={2135.48}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={830.66}
          cy={2135.05}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={827.46}
          cy={2134.68}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={824.27}
          cy={2134.35}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={821.07}
          cy={2134.09}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={817.86}
          cy={2133.88}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={814.66}
          cy={2133.73}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={811.46}
          cy={2133.64}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={808.26}
          cy={2133.62}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={805.05}
          cy={2133.67}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={801.85}
          cy={2133.79}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={798.65}
          cy={2133.98}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={795.45}
          cy={2134.25}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={792.25}
          cy={2134.59}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={789.05}
          cy={2135.02}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={785.85}
          cy={2135.54}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={782.64}
          cy={2136.17}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={779.45}
          cy={2136.9}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={776.28}
          cy={2137.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={773.12}
          cy={2138.68}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={769.99}
          cy={2139.73}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={766.89}
          cy={2140.87}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={763.83}
          cy={2142.11}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={760.81}
          cy={2143.45}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={757.84}
          cy={2144.89}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={754.91}
          cy={2146.42}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={752.05}
          cy={2148.04}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={749.24}
          cy={2149.75}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={746.5}
          cy={2151.55}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={743.83}
          cy={2153.44}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={741.24}
          cy={2155.41}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={738.72}
          cy={2157.47}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={736.3}
          cy={2159.61}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={733.96}
          cy={2161.83}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={731.73}
          cy={2164.12}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={729.59}
          cy={2166.5}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={727.56}
          cy={2168.95}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={725.64}
          cy={2171.48}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={723.83}
          cy={2174.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={722.15}
          cy={2176.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={720.59}
          cy={2179.48}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={719.17}
          cy={2182.29}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={717.88}
          cy={2185.16}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={716.73}
          cy={2188.1}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={715.73}
          cy={2191.09}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={714.88}
          cy={2194.15}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={714.19}
          cy={2197.27}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={713.66}
          cy={2200.45}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={713.29}
          cy={2203.7}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={713.12}
          cy={2206.93}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={713.13}
          cy={2210.12}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={713.33}
          cy={2213.28}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={713.7}
          cy={2216.41}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={714.24}
          cy={2219.49}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={714.95}
          cy={2222.52}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={715.81}
          cy={2225.51}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={716.84}
          cy={2228.44}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={718.01}
          cy={2231.33}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={719.33}
          cy={2234.15}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={720.79}
          cy={2236.92}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={722.38}
          cy={2239.62}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={724.11}
          cy={2242.26}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={726.7}
          cy={2245.79}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={727.97}
          cy={2247.38}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={730.1}
          cy={2249.85}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={732.35}
          cy={2252.24}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={734.7}
          cy={2254.55}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={737.16}
          cy={2256.77}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={739.71}
          cy={2258.89}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={742.36}
          cy={2260.93}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={745.09}
          cy={2262.86}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={747.9}
          cy={2264.7}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={750.79}
          cy={2266.43}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={753.75}
          cy={2268.05}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={756.76}
          cy={2269.57}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={759.84}
          cy={2270.97}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={762.97}
          cy={2272.25}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={766.15}
          cy={2273.41}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={769.37}
          cy={2274.45}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={772.63}
          cy={2275.36}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={775.91}
          cy={2276.15}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={779.22}
          cy={2276.8}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={782.55}
          cy={2277.31}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={785.9}
          cy={2277.69}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={789.25}
          cy={2277.92}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={792.61}
          cy={2278.01}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={795.96}
          cy={2277.95}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={799.3}
          cy={2277.73}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={802.63}
          cy={2277.36}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={805.95}
          cy={2276.84}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={809.23}
          cy={2276.15}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={812.47}
          cy={2275.3}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={815.62}
          cy={2274.34}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={818.73}
          cy={2273.27}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={821.78}
          cy={2272.1}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={824.77}
          cy={2270.82}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={827.71}
          cy={2269.43}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={830.59}
          cy={2267.95}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={833.42}
          cy={2266.37}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={836.18}
          cy={2264.7}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={838.89}
          cy={2262.93}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={841.55}
          cy={2261.08}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={844.14}
          cy={2259.13}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={846.67}
          cy={2257.11}
          r={36.54}
        />
        <circle className="front_svg__circle" cx={849.15} cy={2255} r={36.54} />
        <circle
          className="front_svg__circle"
          cx={851.56}
          cy={2252.82}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={853.91}
          cy={2250.56}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={856.2}
          cy={2248.23}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={858.43}
          cy={2245.83}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={860.59}
          cy={2243.35}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={862.69}
          cy={2240.82}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={864.72}
          cy={2238.22}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={866.69}
          cy={2235.56}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={868.59}
          cy={2232.85}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={870.43}
          cy={2230.08}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={872.2}
          cy={2227.26}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={873.9}
          cy={2224.39}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={875.54}
          cy={2221.47}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={877.1}
          cy={2218.51}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={878.6}
          cy={2215.51}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={880.02}
          cy={2212.47}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={881.38}
          cy={2209.39}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={882.66}
          cy={2206.28}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={883.87}
          cy={2203.14}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={885.01}
          cy={2199.97}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={886.08}
          cy={2196.78}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={887.07}
          cy={2193.56}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={887.99}
          cy={2190.33}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={888.83}
          cy={2187.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={889.6}
          cy={2183.8}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={890.29}
          cy={2180.52}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={890.91}
          cy={2177.24}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={891.45}
          cy={2173.94}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={891.91}
          cy={2170.64}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={892.29}
          cy={2167.34}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={890.67}
          cy={2168.2}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={888.58}
          cy={2170.73}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={886.75}
          cy={2173.38}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={885.17}
          cy={2176.17}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={883.85}
          cy={2179.06}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={882.77}
          cy={2182.05}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={881.92}
          cy={2185.12}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={881.32}
          cy={2188.26}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={880.89}
          cy={2192.21}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={880.79}
          cy={2194.5}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={880.84}
          cy={2197.57}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={881.07}
          cy={2200.65}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={881.49}
          cy={2203.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={882.09}
          cy={2206.82}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={882.87}
          cy={2209.87}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={883.82}
          cy={2212.89}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={884.94}
          cy={2215.87}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={886.22}
          cy={2218.78}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={887.66}
          cy={2221.63}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={889.25}
          cy={2224.4}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={890.99}
          cy={2227.08}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={892.88}
          cy={2229.65}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={894.9}
          cy={2232.11}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={897.07}
          cy={2234.45}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={899.36}
          cy={2236.64}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={901.78}
          cy={2238.69}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={904.33}
          cy={2240.57}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={906.99}
          cy={2242.28}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={909.76}
          cy={2243.81}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={912.61}
          cy={2245.13}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={915.5}
          cy={2246.28}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={918.41}
          cy={2247.28}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={921.36}
          cy={2248.12}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={924.34}
          cy={2248.81}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={927.35}
          cy={2249.35}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={930.37}
          cy={2249.76}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={933.41}
          cy={2250.02}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={936.47}
          cy={2250.14}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={939.53}
          cy={2250.13}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={942.6}
          cy={2249.99}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={945.68}
          cy={2249.73}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={948.74}
          cy={2249.33}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={951.8}
          cy={2248.82}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={954.85}
          cy={2248.19}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={957.89}
          cy={2247.45}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={960.91}
          cy={2246.59}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={963.9}
          cy={2245.62}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={966.87}
          cy={2244.55}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={969.81}
          cy={2243.38}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={972.71}
          cy={2242.11}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={975.57}
          cy={2240.75}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={978.4}
          cy={2239.29}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={981.17}
          cy={2237.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={983.9}
          cy={2236.11}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={986.57}
          cy={2234.39}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={989.18}
          cy={2232.6}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={991.73}
          cy={2230.73}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={994.21}
          cy={2228.79}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={996.63}
          cy={2226.77}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={998.96}
          cy={2224.69}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1001.24}
          cy={2222.56}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1003.45}
          cy={2220.38}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1005.61}
          cy={2218.16}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1007.71}
          cy={2215.88}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1009.76}
          cy={2213.56}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1011.76}
          cy={2211.2}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1013.72}
          cy={2208.8}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1015.62}
          cy={2206.36}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1017.49}
          cy={2203.88}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1019.3}
          cy={2201.37}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1021.08}
          cy={2198.82}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1022.82}
          cy={2196.24}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1024.53}
          cy={2193.64}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1026.19}
          cy={2191}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1027.83}
          cy={2188.34}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1029.43}
          cy={2185.66}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1031}
          cy={2182.95}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1032.55}
          cy={2180.23}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1034.06}
          cy={2177.49}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1035.56}
          cy={2174.73}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1037.03}
          cy={2171.96}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1038.48}
          cy={2169.17}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1039.92}
          cy={2166.38}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1041.33}
          cy={2163.57}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1042.74}
          cy={2160.77}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1044.12}
          cy={2157.95}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1045.5}
          cy={2155.13}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1046.87}
          cy={2152.32}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1048.23}
          cy={2149.5}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1049.59}
          cy={2146.69}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1051.15}
          cy={2143.43}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1052.71}
          cy={2140.17}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1054.27}
          cy={2136.89}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1055.82}
          cy={2133.6}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1057.35}
          cy={2130.29}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1058.86}
          cy={2126.98}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1060.34}
          cy={2123.65}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1061.8}
          cy={2120.31}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1063.22}
          cy={2116.95}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1064.6}
          cy={2113.59}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1065.94}
          cy={2110.21}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1067.24}
          cy={2106.82}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1068.48}
          cy={2103.42}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1069.66}
          cy={2100}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1070.79}
          cy={2096.57}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1071.85}
          cy={2093.13}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1072.83}
          cy={2089.68}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1073.75}
          cy={2086.21}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1074.58}
          cy={2082.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1075.33}
          cy={2079.25}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1076}
          cy={2075.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1076.57}
          cy={2072.23}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1077.04}
          cy={2068.7}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1077.41}
          cy={2065.16}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1077.67}
          cy={2061.6}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1077.82}
          cy={2058.04}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1077.86}
          cy={2054.46}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1077.78}
          cy={2050.87}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1077.56}
          cy={2047.24}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1077.16}
          cy={2043.61}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1076.6}
          cy={2039.99}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1075.87}
          cy={2036.38}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1074.99}
          cy={2032.8}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1073.94}
          cy={2029.25}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1072.74}
          cy={2025.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1071.39}
          cy={2022.29}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1069.89}
          cy={2018.91}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1068.25}
          cy={2015.6}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1066.48}
          cy={2012.37}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1064.56}
          cy={2009.23}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1062.52}
          cy={2006.2}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1060.35}
          cy={2003.28}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1058.05}
          cy={2000.49}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1055.63}
          cy={1997.82}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1053.1}
          cy={1995.3}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1050.45}
          cy={1992.93}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1047.7}
          cy={1990.72}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1044.84}
          cy={1988.69}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1041.87}
          cy={1986.83}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1038.81}
          cy={1985.17}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1035.66}
          cy={1983.7}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1032.41}
          cy={1982.45}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1029.08}
          cy={1981.41}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1025.67}
          cy={1980.61}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1022.17}
          cy={1980.04}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1018.61}
          cy={1979.72}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1015}
          cy={1979.66}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1011.44}
          cy={1979.86}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1007.93}
          cy={1980.31}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1004.48}
          cy={1980.99}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1001.09}
          cy={1981.9}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={997.77}
          cy={1983.02}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={994.53}
          cy={1984.36}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={991.35}
          cy={1985.9}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={988.26}
          cy={1987.62}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={985.26}
          cy={1989.53}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={982.35}
          cy={1991.6}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={979.54}
          cy={1993.84}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={976.82}
          cy={1996.22}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={974.21}
          cy={1998.75}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={971.72}
          cy={2001.41}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={969.34}
          cy={2004.19}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={967.08}
          cy={2007.09}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={964.94}
          cy={2010.09}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={962.94}
          cy={2013.18}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={961.07}
          cy={2016.35}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={959.34}
          cy={2019.6}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={957.75}
          cy={2022.92}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={956.31}
          cy={2026.29}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={955.03}
          cy={2029.71}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={953.91}
          cy={2033.16}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={953.04}
          cy={2036.21}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={952.27}
          cy={2039.27}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={951.59}
          cy={2042.35}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={950.99}
          cy={2045.44}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={950.48}
          cy={2048.55}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={950.05}
          cy={2051.66}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={949.69}
          cy={2054.79}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={949.41}
          cy={2057.93}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={949.2}
          cy={2061.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={949.05}
          cy={2064.22}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={948.97}
          cy={2067.38}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={948.94}
          cy={2070.55}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={948.97}
          cy={2073.72}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={949.05}
          cy={2076.9}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={949.19}
          cy={2080.08}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={949.36}
          cy={2083.26}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={949.58}
          cy={2086.44}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={949.84}
          cy={2089.63}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={950.13}
          cy={2092.82}
          r={36.54}
        />
        <circle className="front_svg__circle" cx={950.46} cy={2096} r={36.54} />
        <circle
          className="front_svg__circle"
          cx={950.81}
          cy={2099.18}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={951.19}
          cy={2102.37}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={951.59}
          cy={2105.54}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={952.01}
          cy={2108.72}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={952.45}
          cy={2111.89}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={952.89}
          cy={2115.05}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={953.34}
          cy={2118.21}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={953.8}
          cy={2121.35}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={954.26}
          cy={2124.5}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={954.72}
          cy={2127.65}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={955.19}
          cy={2130.8}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={955.67}
          cy={2133.95}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={956.16}
          cy={2137.1}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={956.67}
          cy={2140.26}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={957.19}
          cy={2143.4}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={957.73}
          cy={2146.55}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={958.3}
          cy={2149.69}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={958.89}
          cy={2152.82}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={959.51}
          cy={2155.95}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={960.16}
          cy={2159.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={960.85}
          cy={2162.17}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={961.57}
          cy={2165.27}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={962.33}
          cy={2168.35}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={963.14}
          cy={2171.42}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={963.99}
          cy={2174.47}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={964.88}
          cy={2177.51}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={965.83}
          cy={2180.52}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={966.83}
          cy={2183.52}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={967.88}
          cy={2186.5}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={968.99}
          cy={2189.46}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={970.17}
          cy={2192.39}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={971.4}
          cy={2195.3}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={972.71}
          cy={2198.18}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={974.08}
          cy={2201.04}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={975.53}
          cy={2203.87}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={977.06}
          cy={2206.67}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={978.68}
          cy={2209.43}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={980.39}
          cy={2212.15}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={982.18}
          cy={2214.82}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={984.05}
          cy={2217.44}
          r={36.54}
        />
        <circle className="front_svg__circle" cx={986} cy={2220} r={36.54} />
        <circle
          className="front_svg__circle"
          cx={988.02}
          cy={2222.51}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={990.12}
          cy={2224.94}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={992.3}
          cy={2227.31}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={994.55}
          cy={2229.59}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={996.86}
          cy={2231.8}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={999.25}
          cy={2233.93}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1001.7}
          cy={2235.96}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1004.21}
          cy={2237.89}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1006.79}
          cy={2239.73}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1009.43}
          cy={2241.46}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1012.13}
          cy={2243.08}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1014.88}
          cy={2244.59}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1017.69}
          cy={2245.98}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1020.55}
          cy={2247.24}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1023.46}
          cy={2248.37}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1026.43}
          cy={2249.37}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1029.44}
          cy={2250.23}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1032.49}
          cy={2250.95}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1035.6}
          cy={2251.52}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1038.74}
          cy={2251.94}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1042.03}
          cy={2252.21}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1045.27}
          cy={2252.32}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1048.48}
          cy={2252.27}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1051.64}
          cy={2252.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1054.76}
          cy={2251.72}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1057.83}
          cy={2251.22}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1060.86}
          cy={2250.59}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1063.85}
          cy={2249.81}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1066.8}
          cy={2248.91}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1069.7}
          cy={2247.87}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1072.56}
          cy={2246.71}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1075.37}
          cy={2245.42}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1078.15}
          cy={2244.02}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1080.87}
          cy={2242.5}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1083.56}
          cy={2240.87}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1086.2}
          cy={2239.14}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1088.8}
          cy={2237.31}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1091.36}
          cy={2235.37}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1093.87}
          cy={2233.34}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1096.34}
          cy={2231.23}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1098.77}
          cy={2229.02}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1101.15}
          cy={2226.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1103.49}
          cy={2224.37}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1105.79}
          cy={2221.93}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1108.04}
          cy={2219.42}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1110.25}
          cy={2216.84}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1112.41}
          cy={2214.2}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1114.54}
          cy={2211.5}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1116.62}
          cy={2208.75}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1118.65}
          cy={2205.94}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1120.64}
          cy={2203.09}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1122.59}
          cy={2200.2}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1124.49}
          cy={2197.26}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1126.35}
          cy={2194.29}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1128.17}
          cy={2191.29}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1129.94}
          cy={2188.26}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1131.67}
          cy={2185.21}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1133.36}
          cy={2182.14}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1135}
          cy={2179.05}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1136.6}
          cy={2175.95}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1138.15}
          cy={2172.84}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1139.66}
          cy={2169.73}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1141.12}
          cy={2166.62}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1142.55}
          cy={2163.52}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1143.92}
          cy={2160.42}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1145.26}
          cy={2157.33}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1146.55}
          cy={2154.27}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1147.82}
          cy={2151.21}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1149.09}
          cy={2148.14}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1150.35}
          cy={2145.08}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1151.6}
          cy={2142.01}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1152.84}
          cy={2138.94}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1154.07}
          cy={2135.86}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1155.3}
          cy={2132.78}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1156.52}
          cy={2129.7}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1157.72}
          cy={2126.62}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1158.92}
          cy={2123.53}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1160.12}
          cy={2120.43}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1161.3}
          cy={2117.34}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1162.47}
          cy={2114.24}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1163.64}
          cy={2111.14}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1164.8}
          cy={2108.03}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1165.95}
          cy={2104.93}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1167.09}
          cy={2101.82}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1168.23}
          cy={2098.7}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1169.35}
          cy={2095.59}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1170.47}
          cy={2092.47}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1171.58}
          cy={2089.34}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1172.68}
          cy={2086.22}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1173.77}
          cy={2083.09}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1174.85}
          cy={2079.96}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1175.93}
          cy={2076.82}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1176.99}
          cy={2073.68}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1178.05}
          cy={2070.54}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1179.1}
          cy={2067.4}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1180.14}
          cy={2064.26}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1181.18}
          cy={2061.11}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1182.2}
          cy={2057.96}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1183.22}
          cy={2054.8}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1184.23}
          cy={2051.64}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1185.22}
          cy={2048.49}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1186.21}
          cy={2045.34}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1187.19}
          cy={2042.2}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1188.15}
          cy={2039.05}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1189.11}
          cy={2035.9}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1190.07}
          cy={2032.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1191.01}
          cy={2029.59}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1191.94}
          cy={2026.43}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1192.87}
          cy={2023.27}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1193.79}
          cy={2020.1}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1194.7}
          cy={2016.94}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1195.6}
          cy={2013.77}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1196.49}
          cy={2010.6}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1197.38}
          cy={2007.43}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1198.25}
          cy={2004.25}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1199.12}
          cy={2001.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1199.98}
          cy={1997.89}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1200.83}
          cy={1994.71}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1201.67}
          cy={1991.53}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1202.5}
          cy={1988.34}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1203.33}
          cy={1985.15}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1204.15}
          cy={1981.96}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1204.95}
          cy={1978.77}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1205.75}
          cy={1975.57}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1206.55}
          cy={1972.37}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1207.33}
          cy={1969.17}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1208.1}
          cy={1965.97}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1208.87}
          cy={1962.77}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1209.63}
          cy={1959.56}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1210.37}
          cy={1956.35}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1211.11}
          cy={1953.14}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1211.85}
          cy={1949.93}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1212.57}
          cy={1946.72}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1213.28}
          cy={1943.5}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1213.99}
          cy={1940.29}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1214.69}
          cy={1937.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1215.38}
          cy={1933.85}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1216.06}
          cy={1930.62}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1216.73}
          cy={1927.4}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1217.39}
          cy={1924.17}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1218.05}
          cy={1920.94}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1218.69}
          cy={1917.71}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1219.33}
          cy={1914.48}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1219.96}
          cy={1911.25}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1220.58}
          cy={1908.01}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1221.19}
          cy={1904.78}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1221.79}
          cy={1901.54}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1222.39}
          cy={1898.3}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1222.97}
          cy={1895.06}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1223.55}
          cy={1891.81}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1224.12}
          cy={1888.57}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1224.68}
          cy={1885.32}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1225.23}
          cy={1882.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1225.77}
          cy={1878.83}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1226.3}
          cy={1875.57}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1226.83}
          cy={1872.32}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1227.35}
          cy={1869.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1227.85}
          cy={1865.82}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1228.35}
          cy={1862.56}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1228.84}
          cy={1859.3}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1229.32}
          cy={1856.04}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1229.8}
          cy={1852.78}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1230.15}
          cy={1851.24}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1230.16}
          cy={1854.53}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1230.12}
          cy={1857.81}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1230.02}
          cy={1861.08}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1229.86}
          cy={1864.34}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1229.66}
          cy={1867.6}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1229.4}
          cy={1870.85}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1229.09}
          cy={1874.09}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1228.74}
          cy={1877.33}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1228.34}
          cy={1880.56}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1227.89}
          cy={1883.78}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1227.41}
          cy={1887}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1226.87}
          cy={1890.21}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1226.3}
          cy={1893.42}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1225.69}
          cy={1896.62}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1225.04}
          cy={1899.81}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1224.35}
          cy={1903}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1223.63}
          cy={1906.18}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1222.87}
          cy={1909.36}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1221.94}
          cy={1913.1}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1221.14}
          cy={1916.17}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1220.16}
          cy={1919.8}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1219.14}
          cy={1923.42}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1218.09}
          cy={1927.04}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1217}
          cy={1930.65}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1215.88}
          cy={1934.26}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1214.74}
          cy={1937.86}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1213.57}
          cy={1941.46}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1212.37}
          cy={1945.06}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1211.15}
          cy={1948.65}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1209.91}
          cy={1952.24}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1208.66}
          cy={1955.83}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1207.39}
          cy={1959.41}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1206.1}
          cy={1962.99}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1204.8}
          cy={1966.57}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1203.49}
          cy={1970.15}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1202.18}
          cy={1973.73}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1200.86}
          cy={1977.3}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1199.54}
          cy={1980.88}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1198.21}
          cy={1984.45}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1196.89}
          cy={1988.03}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1195.56}
          cy={1991.6}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1194.25}
          cy={1995.18}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1192.94}
          cy={1998.75}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1191.64}
          cy={2002.33}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1190.35}
          cy={2005.91}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1189.07}
          cy={2009.49}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1187.81}
          cy={2013.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1186.57}
          cy={2016.65}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1185.35}
          cy={2020.24}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1184.15}
          cy={2023.82}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1182.97}
          cy={2027.41}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1181.82}
          cy={2031.02}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1180.7}
          cy={2034.66}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1179.61}
          cy={2038.33}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1178.57}
          cy={2042.02}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1177.56}
          cy={2045.73}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1176.59}
          cy={2049.46}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1175.66}
          cy={2053.22}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1174.77}
          cy={2056.99}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1173.93}
          cy={2060.77}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1173.14}
          cy={2064.57}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1172.39}
          cy={2068.39}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1171.7}
          cy={2072.21}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1171.05}
          cy={2076.04}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1170.47}
          cy={2079.88}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1169.93}
          cy={2083.72}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1169.46}
          cy={2087.56}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1169.04}
          cy={2091.41}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1168.68}
          cy={2095.25}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1168.39}
          cy={2099.1}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1168.16}
          cy={2102.93}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1168}
          cy={2106.77}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1167.9}
          cy={2110.59}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1167.87}
          cy={2114.4}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1167.92}
          cy={2118.2}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1168.04}
          cy={2121.99}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1168.23}
          cy={2125.76}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1168.5}
          cy={2129.52}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1168.85}
          cy={2133.25}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1169.27}
          cy={2136.97}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1169.78}
          cy={2140.66}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1170.37}
          cy={2144.33}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1171.05}
          cy={2147.97}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1171.82}
          cy={2151.58}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1172.67}
          cy={2155.16}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1173.62}
          cy={2158.71}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1174.65}
          cy={2162.23}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1175.78}
          cy={2165.71}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1177.01}
          cy={2169.15}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1178.33}
          cy={2172.55}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1179.75}
          cy={2175.92}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1181.28}
          cy={2179.24}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1182.91}
          cy={2182.51}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1184.64}
          cy={2185.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1186.47}
          cy={2188.92}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1188.42}
          cy={2192.05}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1190.47}
          cy={2195.12}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1192.64}
          cy={2198.14}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1194.92}
          cy={2201.11}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1197.31}
          cy={2204.02}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1199.19}
          cy={2206.16}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1201.13}
          cy={2208.24}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1203.12}
          cy={2210.26}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1205.17}
          cy={2212.21}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1207.27}
          cy={2214.11}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1209.42}
          cy={2215.95}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1211.62}
          cy={2217.72}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1213.86}
          cy={2219.43}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1216.16}
          cy={2221.08}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1218.49}
          cy={2222.67}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1220.87}
          cy={2224.19}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1223.29}
          cy={2225.66}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1225.75}
          cy={2227.06}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1228.24}
          cy={2228.39}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1230.77}
          cy={2229.66}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1233.33}
          cy={2230.87}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1235.92}
          cy={2232.01}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1238.54}
          cy={2233.09}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1241.19}
          cy={2234.11}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1243.87}
          cy={2235.06}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1246.56}
          cy={2235.94}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1249.28}
          cy={2236.76}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1252.02}
          cy={2237.51}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1254.78}
          cy={2238.2}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1257.55}
          cy={2238.82}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1260.34}
          cy={2239.37}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1263.14}
          cy={2239.85}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1265.95}
          cy={2240.27}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1268.78}
          cy={2240.62}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1271.6}
          cy={2240.91}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1274.44}
          cy={2241.12}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1277.28}
          cy={2241.27}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1280.12}
          cy={2241.35}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1282.96}
          cy={2241.36}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1285.79}
          cy={2241.3}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1288.63}
          cy={2241.17}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1291.46}
          cy={2240.97}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1294.28}
          cy={2240.7}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1297.09}
          cy={2240.36}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1299.89}
          cy={2239.95}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1302.68}
          cy={2239.47}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1305.46}
          cy={2238.92}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1308.21}
          cy={2238.3}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1310.95}
          cy={2237.61}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1313.67}
          cy={2236.84}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1316.37}
          cy={2236}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1319.04}
          cy={2235.09}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1321.69}
          cy={2234.11}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1324.31}
          cy={2233.05}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1326.91}
          cy={2231.92}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1329.47}
          cy={2230.72}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1332}
          cy={2229.44}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1334.49}
          cy={2228.09}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1336.95}
          cy={2226.67}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1339.37}
          cy={2225.17}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1341.74}
          cy={2223.6}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1344.06}
          cy={2221.96}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1346.33}
          cy={2220.26}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1348.55}
          cy={2218.5}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1350.71}
          cy={2216.68}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1352.82}
          cy={2214.79}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1354.88}
          cy={2212.85}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1356.88}
          cy={2210.86}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1358.83}
          cy={2208.81}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1360.72}
          cy={2206.71}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1362.55}
          cy={2204.56}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1364.33}
          cy={2202.36}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1366.04}
          cy={2200.12}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1367.71}
          cy={2197.83}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1369.31}
          cy={2195.5}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1370.85}
          cy={2193.12}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1372.34}
          cy={2190.71}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1373.76}
          cy={2188.26}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1375.12}
          cy={2185.77}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1376.43}
          cy={2183.25}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1377.67}
          cy={2180.7}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1378.85}
          cy={2178.12}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1379.97}
          cy={2175.51}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1381.02}
          cy={2172.87}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1382.01}
          cy={2170.2}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1382.94}
          cy={2167.5}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1383.9}
          cy={2164.46}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1384.79}
          cy={2161.37}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1385.59}
          cy={2158.27}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1386.3}
          cy={2155.14}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1386.93}
          cy={2151.99}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1387.48}
          cy={2148.84}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1387.94}
          cy={2145.66}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1388.31}
          cy={2142.48}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1388.59}
          cy={2139.29}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1388.78}
          cy={2136.1}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1388.88}
          cy={2132.91}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1388.9}
          cy={2129.71}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1388.82}
          cy={2126.52}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1388.65}
          cy={2123.33}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1388.39}
          cy={2120.15}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1388.03}
          cy={2116.98}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1387.58}
          cy={2113.83}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1387.04}
          cy={2110.68}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1386.39}
          cy={2107.56}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1385.66}
          cy={2104.46}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1384.82}
          cy={2101.38}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1383.89}
          cy={2098.33}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1382.86}
          cy={2095.3}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1381.73}
          cy={2092.31}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1380.5}
          cy={2089.35}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1378.7}
          cy={2087.85}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1375.9}
          cy={2089.4}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1373.13}
          cy={2091.03}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1370.4}
          cy={2092.73}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1367.7}
          cy={2094.5}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1365.06}
          cy={2096.33}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1362.45}
          cy={2098.23}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1359.9}
          cy={2100.2}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1357.4}
          cy={2102.24}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1354.96}
          cy={2104.33}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1352.57}
          cy={2106.49}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1350.25}
          cy={2108.71}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1347.99}
          cy={2111}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1345.81}
          cy={2113.34}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1343.69}
          cy={2115.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1341.65}
          cy={2118.2}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1339.68}
          cy={2120.71}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1337.8}
          cy={2123.28}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1336.01}
          cy={2125.9}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1334.3}
          cy={2128.58}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1332.68}
          cy={2131.31}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1331.15}
          cy={2134.09}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1329.73}
          cy={2136.92}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1328.4}
          cy={2139.79}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1327.18}
          cy={2142.72}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1326.06}
          cy={2145.69}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1325.05}
          cy={2148.71}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1324.16}
          cy={2151.77}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1323.39}
          cy={2154.88}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1322.75}
          cy={2158.03}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1322.25}
          cy={2161.21}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1321.89}
          cy={2164.42}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1321.66}
          cy={2167.64}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1321.58}
          cy={2170.86}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1321.62}
          cy={2174.09}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1321.8}
          cy={2177.32}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1322.12}
          cy={2180.54}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1322.57}
          cy={2183.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1323.15}
          cy={2186.91}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1323.86}
          cy={2190.05}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1324.7}
          cy={2193.16}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1325.67}
          cy={2196.22}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1326.76}
          cy={2199.23}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1327.99}
          cy={2202.18}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1329.34}
          cy={2205.06}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1330.82}
          cy={2207.88}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1332.42}
          cy={2210.61}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1334.15}
          cy={2213.26}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1336}
          cy={2215.82}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1337.98}
          cy={2218.28}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1340.08}
          cy={2220.63}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1342.29}
          cy={2222.87}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1344.63}
          cy={2224.99}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1347.09}
          cy={2226.99}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1349.66}
          cy={2228.85}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1352.35}
          cy={2230.58}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1355.32}
          cy={2232.24}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1358.35}
          cy={2233.71}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1361.43}
          cy={2234.99}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1364.57}
          cy={2236.09}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1367.74}
          cy={2237}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1370.96}
          cy={2237.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1374.21}
          cy={2238.3}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1377.49}
          cy={2238.69}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1380.79}
          cy={2238.91}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1384.11}
          cy={2238.97}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1387.44}
          cy={2238.88}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1390.78}
          cy={2238.63}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1394.12}
          cy={2238.22}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1397.45}
          cy={2237.67}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1400.77}
          cy={2236.98}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1404.08}
          cy={2236.15}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1407.37}
          cy={2235.18}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1410.63}
          cy={2234.08}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1413.85}
          cy={2232.85}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1417.04}
          cy={2231.5}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1420.19}
          cy={2230.03}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1423.28}
          cy={2228.44}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1426.33}
          cy={2226.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1429.31}
          cy={2224.93}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1432.23}
          cy={2223.02}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1435.07}
          cy={2221}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1437.85}
          cy={2218.89}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1440.53}
          cy={2216.68}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1443.14}
          cy={2214.39}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1445.65}
          cy={2212.01}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1448.06}
          cy={2209.54}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1450.36}
          cy={2207}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1452.56}
          cy={2204.41}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1454.68}
          cy={2201.77}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1456.72}
          cy={2199.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1458.69}
          cy={2196.33}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1460.58}
          cy={2193.54}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1462.41}
          cy={2190.71}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1464.16}
          cy={2187.84}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1465.85}
          cy={2184.92}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1467.48}
          cy={2181.97}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1469.05}
          cy={2178.98}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1470.55}
          cy={2175.96}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1472.01}
          cy={2172.91}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1473.41}
          cy={2169.82}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1474.75}
          cy={2166.71}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1476.05}
          cy={2163.56}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1477.31}
          cy={2160.4}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1478.52}
          cy={2157.21}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1479.69}
          cy={2154}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1480.81}
          cy={2150.77}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1481.91}
          cy={2147.52}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1482.97}
          cy={2144.26}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1484}
          cy={2140.99}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1484.99}
          cy={2137.7}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1485.97}
          cy={2134.4}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1486.91}
          cy={2131.1}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1487.84}
          cy={2127.79}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1488.75}
          cy={2124.47}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1489.63}
          cy={2121.16}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1490.51}
          cy={2117.84}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1491.37}
          cy={2114.52}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1492.22}
          cy={2111.21}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1493.07}
          cy={2107.91}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1495.06}
          cy={2108.26}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1497.59}
          cy={2110.54}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1500.05}
          cy={2112.89}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1502.45}
          cy={2115.31}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1504.78}
          cy={2117.79}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1507.05}
          cy={2120.32}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1509.25}
          cy={2122.92}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1511.37}
          cy={2125.57}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1513.43}
          cy={2128.27}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1515.43}
          cy={2131.03}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1517.35}
          cy={2133.83}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1519.2}
          cy={2136.69}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1520.98}
          cy={2139.59}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1522.68}
          cy={2142.53}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1524.32}
          cy={2145.52}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1525.88}
          cy={2148.54}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1527.38}
          cy={2151.63}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1528.77}
          cy={2154.66}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1530.09}
          cy={2157.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1531.34}
          cy={2160.86}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1532.51}
          cy={2164}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1533.62}
          cy={2167.18}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1534.64}
          cy={2170.37}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1535.6}
          cy={2173.6}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1536.47}
          cy={2176.84}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1537.28}
          cy={2180.1}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1538}
          cy={2183.38}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1538.65}
          cy={2186.67}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1539.22}
          cy={2189.98}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1539.71}
          cy={2193.3}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1540.12}
          cy={2196.63}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1540.45}
          cy={2199.97}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1540.71}
          cy={2203.31}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1540.88}
          cy={2206.66}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1540.97}
          cy={2210.01}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1540.98}
          cy={2213.37}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1540.91}
          cy={2216.71}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1540.76}
          cy={2220.06}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1540.52}
          cy={2223.4}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1540.2}
          cy={2226.73}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1539.79}
          cy={2230.06}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1539.3}
          cy={2233.37}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1538.73}
          cy={2236.67}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1538.06}
          cy={2239.96}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1537.32}
          cy={2243.22}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1536.48}
          cy={2246.47}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1535.56}
          cy={2249.7}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1534.91}
          cy={2251.11}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1535.17}
          cy={2247.75}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1535.45}
          cy={2244.38}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1535.74}
          cy={2241.01}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1536.06}
          cy={2237.63}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1536.4}
          cy={2234.25}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1536.78}
          cy={2230.87}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1537.19}
          cy={2227.5}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1537.64}
          cy={2224.13}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1538.14}
          cy={2220.78}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1538.7}
          cy={2217.43}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1539.3}
          cy={2214.11}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1539.98}
          cy={2210.81}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1540.71}
          cy={2207.53}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1541.52}
          cy={2204.29}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1542.41}
          cy={2201.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1543.38}
          cy={2197.88}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1544.43}
          cy={2194.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1545.58}
          cy={2191.63}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1546.82}
          cy={2188.57}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1548.17}
          cy={2185.55}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1549.62}
          cy={2182.59}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1551.18}
          cy={2179.68}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1552.86}
          cy={2176.82}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1554.66}
          cy={2174.03}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1556.59}
          cy={2171.3}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1558.69}
          cy={2168.63}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1560.97}
          cy={2166.08}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1563.4}
          cy={2163.66}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1565.98}
          cy={2161.38}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1568.69}
          cy={2159.23}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1571.52}
          cy={2157.24}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1574.46}
          cy={2155.4}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1577.49}
          cy={2153.72}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1580.59}
          cy={2152.21}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1583.77}
          cy={2150.88}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1586.99}
          cy={2149.73}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1590.26}
          cy={2148.77}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1593.55}
          cy={2148.01}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1596.85}
          cy={2147.45}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1600.15}
          cy={2147.1}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1603.44}
          cy={2146.97}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1606.71}
          cy={2147.06}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1609.93}
          cy={2147.39}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1613.1}
          cy={2147.96}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1616.21}
          cy={2148.77}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1619.23}
          cy={2149.83}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1622.16}
          cy={2151.15}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1624.99}
          cy={2152.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1627.69}
          cy={2154.6}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1630.26}
          cy={2156.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1632.55}
          cy={2159}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1634.61}
          cy={2161.39}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1636.47}
          cy={2163.89}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1638.13}
          cy={2166.5}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1639.61}
          cy={2169.22}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1640.94}
          cy={2172.04}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1642.11}
          cy={2174.94}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1643.15}
          cy={2177.91}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1644.07}
          cy={2180.96}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1644.89}
          cy={2184.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1645.62}
          cy={2187.24}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1646.27}
          cy={2190.45}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1646.87}
          cy={2193.7}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1647.42}
          cy={2196.99}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1647.94}
          cy={2200.29}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1648.45}
          cy={2203.61}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1648.95}
          cy={2206.93}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1649.48}
          cy={2210.25}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1650.03}
          cy={2213.56}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1650.63}
          cy={2216.85}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1651.28}
          cy={2220.12}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1652.01}
          cy={2223.35}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1652.84}
          cy={2226.54}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1653.76}
          cy={2229.68}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1654.81}
          cy={2232.76}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1656}
          cy={2235.79}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1657.34}
          cy={2238.75}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1658.82}
          cy={2241.64}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1660.43}
          cy={2244.45}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1662.17}
          cy={2247.19}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1664.03}
          cy={2249.84}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1666.01}
          cy={2252.41}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1668.11}
          cy={2254.9}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1670.31}
          cy={2257.28}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1672.61}
          cy={2259.58}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1675.01}
          cy={2261.77}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1677.51}
          cy={2263.86}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1680.09}
          cy={2265.85}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1682.75}
          cy={2267.72}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1685.49}
          cy={2269.48}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1688.3}
          cy={2271.13}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1691.17}
          cy={2272.65}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1694.11}
          cy={2274.04}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1697.1}
          cy={2275.31}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1700.14}
          cy={2276.45}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1703.23}
          cy={2277.45}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1706.36}
          cy={2278.31}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1709.52}
          cy={2279.03}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1712.71}
          cy={2279.61}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1715.93}
          cy={2280.03}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1719.16}
          cy={2280.3}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1722.41}
          cy={2280.41}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1725.67}
          cy={2280.36}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1728.91}
          cy={2280.15}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1732.14}
          cy={2279.78}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1735.34}
          cy={2279.26}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1738.52}
          cy={2278.59}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1741.65}
          cy={2277.77}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1744.75}
          cy={2276.8}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1747.8}
          cy={2275.7}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1750.8}
          cy={2274.46}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1753.75}
          cy={2273.1}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1756.64}
          cy={2271.6}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1759.46}
          cy={2269.98}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1762.21}
          cy={2268.24}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1764.89}
          cy={2266.39}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1767.48}
          cy={2264.43}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1769.99}
          cy={2262.36}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1772.41}
          cy={2260.18}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1774.74}
          cy={2257.9}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1776.97}
          cy={2255.53}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1779.09}
          cy={2253.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1781.1}
          cy={2250.52}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1782.99}
          cy={2247.88}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1784.77}
          cy={2245.17}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1786.42}
          cy={2242.38}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1787.94}
          cy={2239.51}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1789.33}
          cy={2236.58}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1790.57}
          cy={2233.59}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1791.67}
          cy={2230.53}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1792.62}
          cy={2227.41}
          r={36.54}
        />
      </g>
			<g id="front_svg__t-stroke">
        <circle
          className="front_svg__circle"
          cx={902.38}
          cy={1731.05}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={902.7}
          cy={1731.04}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={907.89}
          cy={1730.88}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={913.07}
          cy={1730.72}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={918.25}
          cy={1730.57}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={923.43}
          cy={1730.41}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={928.62}
          cy={1730.25}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={933.8}
          cy={1730.1}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={938.98}
          cy={1729.94}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={944.16}
          cy={1729.78}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={949.34}
          cy={1729.62}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={954.53}
          cy={1729.47}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={959.71}
          cy={1729.31}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={964.89}
          cy={1729.15}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={970.07}
          cy={1728.99}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={975.25}
          cy={1728.84}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={980.44}
          cy={1728.68}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={985.62}
          cy={1728.52}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={990.8}
          cy={1728.37}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={995.98}
          cy={1728.21}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1001.17}
          cy={1728.05}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1006.35}
          cy={1727.89}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1011.53}
          cy={1727.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1016.71}
          cy={1727.58}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1021.89}
          cy={1727.42}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1027.08}
          cy={1727.26}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1032.26}
          cy={1727.11}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1037.44}
          cy={1726.95}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1042.62}
          cy={1726.79}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1047.81}
          cy={1726.63}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1052.99}
          cy={1726.48}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1058.17}
          cy={1726.32}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1063.35}
          cy={1726.16}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1068.53}
          cy={1726.01}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1073.72}
          cy={1725.85}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1078.9}
          cy={1725.69}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1084.08}
          cy={1725.53}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1089.26}
          cy={1725.38}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1094.44}
          cy={1725.22}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1099.63}
          cy={1725.06}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1104.81}
          cy={1724.9}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1109.99}
          cy={1724.75}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1115.17}
          cy={1724.59}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1120.36}
          cy={1724.43}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1125.54}
          cy={1724.28}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1130.72}
          cy={1724.12}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1135.9}
          cy={1723.96}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1141.08}
          cy={1723.8}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1146.27}
          cy={1723.65}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1151.45}
          cy={1723.49}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1156.63}
          cy={1723.33}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1161.81}
          cy={1723.17}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1166.99}
          cy={1723.02}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1172.18}
          cy={1722.86}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1177.36}
          cy={1722.7}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1182.54}
          cy={1722.54}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1187.72}
          cy={1722.39}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1192.91}
          cy={1722.23}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1198.09}
          cy={1722.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1203.27}
          cy={1721.92}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1208.45}
          cy={1721.76}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1213.63}
          cy={1721.6}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1218.82}
          cy={1721.44}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1224}
          cy={1721.29}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1229.18}
          cy={1721.13}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1234.36}
          cy={1720.97}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1239.55}
          cy={1720.81}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1244.73}
          cy={1720.66}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1249.91}
          cy={1720.5}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1255.09}
          cy={1720.34}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1260.27}
          cy={1720.19}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1265.46}
          cy={1720.03}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1270.64}
          cy={1719.87}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1275.82}
          cy={1719.71}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1281}
          cy={1719.56}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1286.18}
          cy={1719.4}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1291.37}
          cy={1719.24}
          r={36.54}
        />
      </g>
      <g id="front_svg__f">
        <circle
          className="front_svg__circle"
          cx={355.01}
          cy={2379.36}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={355.73}
          cy={2379.12}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={361.44}
          cy={2377.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={367.02}
          cy={2374.8}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={372.46}
          cy={2372.31}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={377.76}
          cy={2369.61}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={382.94}
          cy={2366.71}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={387.99}
          cy={2363.61}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={392.91}
          cy={2360.33}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={397.71}
          cy={2356.87}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={402.38}
          cy={2353.23}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={407.96}
          cy={2348.52}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={411.43}
          cy={2345.39}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={415.8}
          cy={2341.2}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={420.06}
          cy={2336.85}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={424.19}
          cy={2332.36}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={428.21}
          cy={2327.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={432.11}
          cy={2322.98}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={435.9}
          cy={2318.1}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={439.58}
          cy={2313.1}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={443.14}
          cy={2307.99}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={446.6}
          cy={2302.78}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={451.41}
          cy={2295.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={456.2}
          cy={2286.82}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={460.76}
          cy={2278.41}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={465.09}
          cy={2269.85}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={469.2}
          cy={2261.17}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={473.1}
          cy={2252.4}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={476.78}
          cy={2243.55}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={480.26}
          cy={2234.65}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={483.54}
          cy={2225.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={486.63}
          cy={2216.82}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={488.11}
          cy={2212.24}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={489.17}
          cy={2209.11}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={490.18}
          cy={2205.97}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={491.19}
          cy={2202.81}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={492.18}
          cy={2199.66}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={493.17}
          cy={2196.49}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={494.15}
          cy={2193.33}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={495.12}
          cy={2190.15}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={496.09}
          cy={2186.98}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={497.05}
          cy={2183.8}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={498.56}
          cy={2178.81}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={500.38}
          cy={2172.73}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={502.2}
          cy={2166.64}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={504.02}
          cy={2160.56}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={505.85}
          cy={2154.47}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={507.69}
          cy={2148.4}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={509.55}
          cy={2142.33}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={511.44}
          cy={2136.27}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={513.36}
          cy={2130.23}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={515.32}
          cy={2124.2}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={517.31}
          cy={2118.23}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={519.33}
          cy={2112.32}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={521.41}
          cy={2106.45}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={523.54}
          cy={2100.6}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={525.74}
          cy={2094.8}
          r={36.54}
        />
        <circle className="front_svg__circle" cx={528} cy={2089.03} r={36.54} />
        <circle
          className="front_svg__circle"
          cx={530.34}
          cy={2083.3}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={532.76}
          cy={2077.62}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={535.27}
          cy={2071.98}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={537.87}
          cy={2066.4}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={540.51}
          cy={2060.98}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={543.15}
          cy={2055.81}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={545.88}
          cy={2050.69}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={548.71}
          cy={2045.63}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={551.65}
          cy={2040.64}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={554.7}
          cy={2035.7}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={557.86}
          cy={2030.83}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={561.14}
          cy={2026.03}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={564.55}
          cy={2021.3}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={568.08}
          cy={2016.64}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={571.88}
          cy={2011.91}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={576.36}
          cy={2006.83}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={581.19}
          cy={2001.93}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={586.32}
          cy={1997.29}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={591.73}
          cy={1992.96}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={597.38}
          cy={1989.03}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={603.22}
          cy={1985.57}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={609.22}
          cy={1982.65}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={615.34}
          cy={1980.34}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={621.55}
          cy={1978.72}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={627.74}
          cy={1977.85}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={633.5}
          cy={1977.77}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={639.23}
          cy={1978.44}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={644.91}
          cy={1979.92}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={650.48}
          cy={1982.25}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={655.6}
          cy={1985.36}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={660.16}
          cy={1989.14}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={664.16}
          cy={1993.52}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={667.58}
          cy={1998.41}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={670.42}
          cy={2003.72}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={672.85}
          cy={2009.9}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={674.39}
          cy={2015.46}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={675.46}
          cy={2021.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={675.9}
          cy={2028.11}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={675.69}
          cy={2034.49}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={674.84}
          cy={2040.78}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={673.33}
          cy={2046.88}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={671.32}
          cy={2052.76}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={668.85}
          cy={2058.44}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={665.98}
          cy={2063.91}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={662.73}
          cy={2069.2}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={660.02}
          cy={2073.11}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={657.27}
          cy={2076.75}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={654.36}
          cy={2080.29}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={651.32}
          cy={2083.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={648.16}
          cy={2087.1}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={644.89}
          cy={2090.36}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={641.54}
          cy={2093.54}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={638.1}
          cy={2096.63}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={634.61}
          cy={2099.64}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={631.07}
          cy={2102.56}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={625.51}
          cy={2106.95}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={619.17}
          cy={2111.69}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={612.7}
          cy={2116.25}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={606.11}
          cy={2120.64}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={599.41}
          cy={2124.84}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={592.6}
          cy={2128.86}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={585.68}
          cy={2132.7}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={578.66}
          cy={2136.36}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={571.55}
          cy={2139.83}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={564.35}
          cy={2143.12}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={558.04}
          cy={2145.82}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={552.26}
          cy={2148.15}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={546.43}
          cy={2150.36}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={540.55}
          cy={2152.45}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={534.64}
          cy={2154.43}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={528.68}
          cy={2156.28}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={522.69}
          cy={2158.02}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={516.67}
          cy={2159.63}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={510.61}
          cy={2161.13}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={504.53}
          cy={2162.5}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={498.42}
          cy={2163.75}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={492.29}
          cy={2164.88}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={486.13}
          cy={2165.88}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={479.96}
          cy={2166.77}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={473.77}
          cy={2167.52}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={467.57}
          cy={2168.15}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={461.36}
          cy={2168.66}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={455.14}
          cy={2169.04}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={448.91}
          cy={2169.29}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={442.68}
          cy={2169.42}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={436.45}
          cy={2169.42}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={430.22}
          cy={2169.29}
          r={36.54}
        />
        <circle className="front_svg__circle" cx={424} cy={2169.03} r={36.54} />
        <circle
          className="front_svg__circle"
          cx={417.79}
          cy={2168.64}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={411.58}
          cy={2168.12}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={405.39}
          cy={2167.47}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={399.21}
          cy={2166.69}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={393.05}
          cy={2165.77}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={386.9}
          cy={2164.73}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={380.78}
          cy={2163.55}
          r={36.54}
        />
      </g>
      <g id="front_svg__ent">
        <circle
          className="front_svg__circle"
          cx={304.71}
          cy={1942.48}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={307.16}
          cy={1942.26}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={312.04}
          cy={1941.75}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={316.91}
          cy={1941.11}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={321.75}
          cy={1940.36}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={326.57}
          cy={1939.49}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={331.36}
          cy={1938.5}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={336.13}
          cy={1937.4}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={340.86}
          cy={1936.19}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={345.57}
          cy={1934.86}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={350.24}
          cy={1933.43}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={354.88}
          cy={1931.89}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={359.49}
          cy={1930.24}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={364.05}
          cy={1928.49}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={368.58}
          cy={1926.63}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={373.06}
          cy={1924.68}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={377.5}
          cy={1922.62}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={381.9}
          cy={1920.47}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={386.25}
          cy={1918.22}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={390.55}
          cy={1915.87}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={394.8}
          cy={1913.43}
          r={36.54}
        />
        <circle className="front_svg__circle" cx={399} cy={1910.9} r={36.54} />
        <circle
          className="front_svg__circle"
          cx={403.15}
          cy={1908.28}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={407.24}
          cy={1905.58}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={411.27}
          cy={1902.78}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={415.25}
          cy={1899.9}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={419.16}
          cy={1896.94}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={423.01}
          cy={1893.89}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={426.8}
          cy={1890.76}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={430.52}
          cy={1887.56}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={434.18}
          cy={1884.28}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={437.76}
          cy={1880.92}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={441.27}
          cy={1877.49}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={444.71}
          cy={1873.98}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={448.08}
          cy={1870.41}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={451.37}
          cy={1866.76}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={454.58}
          cy={1863.05}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={457.71}
          cy={1859.27}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={460.76}
          cy={1855.43}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={463.72}
          cy={1851.52}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={466.6}
          cy={1847.56}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={469.35}
          cy={1843.6}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={472.1}
          cy={1839.45}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={474.71}
          cy={1835.32}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={477.22}
          cy={1831.13}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={479.65}
          cy={1826.89}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={481.98}
          cy={1822.59}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={484.21}
          cy={1818.25}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={486.34}
          cy={1813.86}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={488.37}
          cy={1809.42}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={490.3}
          cy={1804.93}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={492.13}
          cy={1800.41}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={493.85}
          cy={1795.84}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={495.46}
          cy={1791.23}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={496.96}
          cy={1786.58}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={498.35}
          cy={1781.89}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={499.63}
          cy={1777.17}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={500.79}
          cy={1772.42}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={501.84}
          cy={1767.63}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={502.77}
          cy={1762.81}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={503.57}
          cy={1757.97}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={504.23}
          cy={1753.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={504.69}
          cy={1748.14}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={504.93}
          cy={1743.2}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={504.91}
          cy={1738.28}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={504.58}
          cy={1733.41}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={503.91}
          cy={1728.6}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={502.85}
          cy={1723.88}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={501.39}
          cy={1719.29}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={499.46}
          cy={1714.83}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={496.98}
          cy={1710.56}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={493.92}
          cy={1706.63}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={490.37}
          cy={1703.1}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={486.41}
          cy={1700.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={482.13}
          cy={1697.59}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={477.61}
          cy={1695.75}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={472.94}
          cy={1694.61}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={468.2}
          cy={1694.26}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={463.48}
          cy={1694.77}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={458.87}
          cy={1696.2}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={454.61}
          cy={1698.5}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={450.8}
          cy={1701.45}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={447.25}
          cy={1705.1}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={443.95}
          cy={1709.33}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={440.99}
          cy={1713.84}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={438.28}
          cy={1718.45}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={435.73}
          cy={1723.13}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={433.33}
          cy={1727.89}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={431.07}
          cy={1732.71}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={428.95}
          cy={1737.59}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={426.97}
          cy={1742.53}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={425.14}
          cy={1747.52}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={423.45}
          cy={1752.57}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={421.9}
          cy={1757.66}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={420.49}
          cy={1762.79}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={419.23}
          cy={1767.96}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={418.11}
          cy={1773.17}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={417.13}
          cy={1778.4}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={416.29}
          cy={1783.66}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={415.6}
          cy={1788.95}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={415.05}
          cy={1794.25}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={414.64}
          cy={1799.56}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={414.37}
          cy={1804.88}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={414.25}
          cy={1810.21}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={414.27}
          cy={1815.54}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={414.43}
          cy={1820.87}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={414.74}
          cy={1826.19}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={415.19}
          cy={1831.51}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={415.78}
          cy={1836.8}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={416.51}
          cy={1842.08}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={417.39}
          cy={1847.33}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={418.41}
          cy={1852.56}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={419.57}
          cy={1857.75}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={420.88}
          cy={1862.92}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={422.32}
          cy={1868.04}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={423.91}
          cy={1873.11}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={425.65}
          cy={1878.15}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={427.52}
          cy={1883.12}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={429.54}
          cy={1888.05}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={431.7}
          cy={1892.91}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={434.01}
          cy={1897.71}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={436.45}
          cy={1902.44}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={439.04}
          cy={1907.1}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={441.38}
          cy={1910.98}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={443.93}
          cy={1914.8}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={446.68}
          cy={1918.5}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={449.65}
          cy={1921.99}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={452.83}
          cy={1925.23}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={456.22}
          cy={1928.13}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={459.83}
          cy={1930.63}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={463.66}
          cy={1932.65}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={467.71}
          cy={1934.13}
          r={36.54}
        />
        <circle className="front_svg__circle" cx={471.99} cy={1935} r={36.54} />
        <circle
          className="front_svg__circle"
          cx={476.43}
          cy={1935.19}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={480.79}
          cy={1934.7}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={485.06}
          cy={1933.61}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={489.21}
          cy={1932.01}
          r={36.54}
        />
        <circle className="front_svg__circle" cx={493.23} cy={1930} r={36.54} />
        <circle
          className="front_svg__circle"
          cx={497.11}
          cy={1927.65}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={500.83}
          cy={1925.05}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={504.38}
          cy={1922.29}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={507.81}
          cy={1919.44}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={511.14}
          cy={1916.49}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={514.37}
          cy={1913.46}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={517.52}
          cy={1910.34}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={520.57}
          cy={1907.15}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={523.55}
          cy={1903.87}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={526.45}
          cy={1900.53}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={529.28}
          cy={1897.12}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={532.03}
          cy={1893.65}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={534.73}
          cy={1890.12}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={537.36}
          cy={1886.53}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={539.93}
          cy={1882.89}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={542.46}
          cy={1879.2}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={544.93}
          cy={1875.47}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={547.36}
          cy={1871.7}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={549.75}
          cy={1867.89}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={552.11}
          cy={1864.05}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={554.43}
          cy={1860.18}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={556.73}
          cy={1856.28}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={559.01}
          cy={1852.37}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={561.26}
          cy={1848.44}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={563.51}
          cy={1844.49}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={565.81}
          cy={1840.41}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={568.17}
          cy={1836.21}
          r={36.54}
        />
        <circle className="front_svg__circle" cx={570.53} cy={1832} r={36.54} />
        <circle
          className="front_svg__circle"
          cx={572.9}
          cy={1827.79}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={575.27}
          cy={1823.59}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={577.66}
          cy={1819.41}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={580.07}
          cy={1815.24}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={582.5}
          cy={1811.1}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={584.96}
          cy={1806.98}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={587.45}
          cy={1802.89}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={589.98}
          cy={1798.84}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={592.55}
          cy={1794.83}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={595.17}
          cy={1790.87}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={597.85}
          cy={1786.96}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={600.58}
          cy={1783.1}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={603.38}
          cy={1779.3}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={606.25}
          cy={1775.56}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={609.19}
          cy={1771.9}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={612.21}
          cy={1768.31}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={615.31}
          cy={1764.79}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={618.5}
          cy={1761.36}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={621.79}
          cy={1758.02}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={625.17}
          cy={1754.76}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={628.66}
          cy={1751.61}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={632.26}
          cy={1748.56}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={635.97}
          cy={1745.61}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={639.86}
          cy={1742.79}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={643.99}
          cy={1740.26}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={648.32}
          cy={1738.22}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={652.81}
          cy={1736.89}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={657.43}
          cy={1736.47}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={662.06}
          cy={1737.14}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={666.21}
          cy={1738.8}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={669.84}
          cy={1741.31}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={672.98}
          cy={1744.55}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={675.67}
          cy={1748.37}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={677.92}
          cy={1752.65}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={679.78}
          cy={1757.26}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={681.27}
          cy={1762.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={682.42}
          cy={1766.93}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={683.27}
          cy={1771.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={683.98}
          cy={1776.73}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={684.62}
          cy={1781.73}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={685.18}
          cy={1786.75}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={685.67}
          cy={1791.77}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={686.09}
          cy={1796.79}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={686.44}
          cy={1801.82}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={686.72}
          cy={1806.86}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={686.92}
          cy={1811.9}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={687.05}
          cy={1816.94}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={687.11}
          cy={1821.99}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={687.1}
          cy={1827.03}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={687.01}
          cy={1832.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={686.85}
          cy={1837.12}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={686.63}
          cy={1842.16}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={686.33}
          cy={1847.19}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={685.95}
          cy={1852.22}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={685.51}
          cy={1857.25}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={684.99}
          cy={1862.26}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={684.41}
          cy={1867.27}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={683.75}
          cy={1872.27}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={683.02}
          cy={1877.27}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={682.22}
          cy={1882.25}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={681.35}
          cy={1887.21}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={680.4}
          cy={1892.17}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={679.39}
          cy={1897.11}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={678.3}
          cy={1902.04}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={677.15}
          cy={1906.95}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={675.92}
          cy={1911.84}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={674.62}
          cy={1916.71}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={674.96}
          cy={1914.77}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={676.09}
          cy={1909.85}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={677.3}
          cy={1904.96}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={678.57}
          cy={1900.08}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={679.91}
          cy={1895.21}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={681.32}
          cy={1890.37}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={682.8}
          cy={1885.55}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={684.34}
          cy={1880.75}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={685.96}
          cy={1875.97}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={687.63}
          cy={1871.21}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={689.38}
          cy={1866.48}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={691.15}
          cy={1861.85}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={692.96}
          cy={1857.34}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={694.82}
          cy={1852.86}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={696.74}
          cy={1848.4}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={698.72}
          cy={1843.96}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={700.76}
          cy={1839.55}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={702.86}
          cy={1835.17}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={705.02}
          cy={1830.82}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={707.24}
          cy={1826.5}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={709.51}
          cy={1822.21}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={711.84}
          cy={1817.95}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={714.23}
          cy={1813.72}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={716.68}
          cy={1809.52}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={719.18}
          cy={1805.36}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={721.74}
          cy={1801.23}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={724.35}
          cy={1797.13}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={727.02}
          cy={1793.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={729.74}
          cy={1789.05}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={732.51}
          cy={1785.06}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={735.35}
          cy={1781.11}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={738.33}
          cy={1777.17}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={741.49}
          cy={1773.28}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={744.81}
          cy={1769.49}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={748.3}
          cy={1765.85}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={751.95}
          cy={1762.42}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={755.75}
          cy={1759.25}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={759.7}
          cy={1756.38}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={763.79}
          cy={1753.87}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={768.03}
          cy={1751.78}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={772.4}
          cy={1750.15}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={776.91}
          cy={1749.04}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={781.54}
          cy={1748.49}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={786.29}
          cy={1748.57}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={791.05}
          cy={1749.3}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={795.52}
          cy={1750.63}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={799.67}
          cy={1752.53}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={803.5}
          cy={1754.94}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={807.03}
          cy={1757.82}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={810.24}
          cy={1761.12}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={813.14}
          cy={1764.81}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={816.53}
          cy={1770.25}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={818.02}
          cy={1773.15}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={819.99}
          cy={1777.72}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={821.66}
          cy={1782.49}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={823.01}
          cy={1787.42}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={824.06}
          cy={1792.45}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={824.79}
          cy={1797.54}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={825.21}
          cy={1802.65}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={825.33}
          cy={1807.73}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={825.14}
          cy={1812.73}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={824.67}
          cy={1817.62}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={824.05}
          cy={1822.48}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={823.3}
          cy={1827.34}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={822.46}
          cy={1832.21}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={821.56}
          cy={1837.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={820.63}
          cy={1841.92}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={819.7}
          cy={1846.78}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={818.8}
          cy={1851.63}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={817.96}
          cy={1856.47}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={817.21}
          cy={1861.31}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={816.59}
          cy={1866.14}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={816.11}
          cy={1870.97}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={815.83}
          cy={1875.78}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={815.75}
          cy={1880.58}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={815.92}
          cy={1885.37}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={816.36}
          cy={1890.15}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={817.11}
          cy={1894.92}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={818.19}
          cy={1899.68}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={819.63}
          cy={1904.32}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={821.38}
          cy={1908.76}
          r={36.54}
        />
        <circle className="front_svg__circle" cx={823.44} cy={1913} r={36.54} />
        <circle
          className="front_svg__circle"
          cx={825.78}
          cy={1917.03}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={828.4}
          cy={1920.85}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={831.29}
          cy={1924.47}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={834.42}
          cy={1927.87}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={837.77}
          cy={1931.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={841.35}
          cy={1934.06}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={845.13}
          cy={1936.84}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={849.09}
          cy={1939.41}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={853.23}
          cy={1941.76}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={857.52}
          cy={1943.9}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={861.98}
          cy={1945.83}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={866.6}
          cy={1947.56}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={871.34}
          cy={1949.06}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={876.18}
          cy={1950.34}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={881.1}
          cy={1951.4}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={886.09}
          cy={1952.23}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={891.14}
          cy={1952.83}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={896.23}
          cy={1953.21}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={901.34}
          cy={1953.36}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={906.46}
          cy={1953.28}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={911.57}
          cy={1952.97}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={916.67}
          cy={1952.43}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={921.73}
          cy={1951.65}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={926.73}
          cy={1950.64}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={931.67}
          cy={1949.4}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={936.53}
          cy={1947.92}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={941.29}
          cy={1946.21}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={945.93}
          cy={1944.26}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={950.45}
          cy={1942.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={954.79}
          cy={1939.7}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={959.01}
          cy={1937.19}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={963.11}
          cy={1934.54}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={967.11}
          cy={1931.77}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={971.01}
          cy={1928.88}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={974.81}
          cy={1925.87}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={978.51}
          cy={1922.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={982.11}
          cy={1919.5}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={985.63}
          cy={1916.16}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={989.06}
          cy={1912.71}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={992.4}
          cy={1909.18}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={995.67}
          cy={1905.55}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={998.85}
          cy={1901.84}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1001.96}
          cy={1898.04}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1005}
          cy={1894.17}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1007.97}
          cy={1890.23}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1010.87}
          cy={1886.22}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1013.7}
          cy={1882.15}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1016.48}
          cy={1878.03}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1019.2}
          cy={1873.85}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1021.86}
          cy={1869.62}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1024.83}
          cy={1864.76}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1027.03}
          cy={1861.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1029.54}
          cy={1856.75}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1032}
          cy={1852.41}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1034.42}
          cy={1848.04}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1036.81}
          cy={1843.66}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1039.17}
          cy={1839.26}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1041.49}
          cy={1834.85}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1043.79}
          cy={1830.44}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1046.07}
          cy={1826.03}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1048.32}
          cy={1821.62}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1050.55}
          cy={1817.22}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1052.77}
          cy={1812.84}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1054.99}
          cy={1808.45}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1057.21}
          cy={1804.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1059.43}
          cy={1799.68}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1061.65}
          cy={1795.3}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1063.87}
          cy={1790.92}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1066.09}
          cy={1786.53}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1068.31}
          cy={1782.15}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1070.53}
          cy={1777.76}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1072.76}
          cy={1773.38}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1074.98}
          cy={1768.99}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1077.2}
          cy={1764.61}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1079.42}
          cy={1760.22}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1081.64}
          cy={1755.84}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1083.86}
          cy={1751.45}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1086.08}
          cy={1747.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1088.3}
          cy={1742.68}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1090.52}
          cy={1738.3}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1092.74}
          cy={1733.92}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1094.96}
          cy={1729.53}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1097.18}
          cy={1725.15}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1099.4}
          cy={1720.76}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1101.62}
          cy={1716.38}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1103.84}
          cy={1711.99}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1106.06}
          cy={1707.61}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1108.28}
          cy={1703.22}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1110.51}
          cy={1698.84}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1112.68}
          cy={1694.43}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1114.93}
          cy={1690.06}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1117.25}
          cy={1685.53}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1119.62}
          cy={1680.83}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1122}
          cy={1676.14}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1124.38}
          cy={1671.44}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1126.76}
          cy={1666.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1129.14}
          cy={1662.05}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1131.52}
          cy={1657.35}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1133.9}
          cy={1652.65}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1136.27}
          cy={1647.96}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1138.65}
          cy={1643.26}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1141.03}
          cy={1638.57}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1143.41}
          cy={1633.87}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1145.79}
          cy={1629.17}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1146.42}
          cy={1627.26}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1143.22}
          cy={1631.45}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1140.03}
          cy={1635.65}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1136.84}
          cy={1639.85}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1133.66}
          cy={1644.06}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1130.49}
          cy={1648.28}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1127.34}
          cy={1652.51}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1124.2}
          cy={1656.76}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1121.09}
          cy={1661.02}
          r={36.54}
        />
        <circle className="front_svg__circle" cx={1118} cy={1665.3} r={36.54} />
        <circle
          className="front_svg__circle"
          cx={1114.94}
          cy={1669.59}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1111.9}
          cy={1673.91}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1108.9}
          cy={1678.24}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1105.94}
          cy={1682.6}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1103.02}
          cy={1686.98}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1100.14}
          cy={1691.39}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1097.31}
          cy={1695.82}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1094.53}
          cy={1700.28}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1091.8}
          cy={1704.77}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1089.12}
          cy={1709.29}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1086.51}
          cy={1713.84}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1083.96}
          cy={1718.43}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1081.47}
          cy={1723.05}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1079.06}
          cy={1727.71}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1076.71}
          cy={1732.41}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1074.44}
          cy={1737.14}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1072.25}
          cy={1741.92}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1070.15}
          cy={1746.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1068.77}
          cy={1750.02}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1067.44}
          cy={1753.32}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1066.16}
          cy={1756.64}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1064.92}
          cy={1759.99}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1063.72}
          cy={1763.35}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1062.57}
          cy={1766.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1061.47}
          cy={1770.14}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1060.42}
          cy={1773.56}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1059.42}
          cy={1776.99}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1058.47}
          cy={1780.44}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1057.58}
          cy={1783.91}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1056.73}
          cy={1787.38}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1055.95}
          cy={1790.87}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1055.21}
          cy={1794.37}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1054.54}
          cy={1797.87}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1053.92}
          cy={1801.39}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1053.37}
          cy={1804.91}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1052.87}
          cy={1808.43}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1052.43}
          cy={1811.96}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1052.06}
          cy={1815.5}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1051.75}
          cy={1819.04}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1051.5}
          cy={1822.57}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1051.32}
          cy={1826.11}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1051.21}
          cy={1829.65}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1051.17}
          cy={1833.18}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1051.19}
          cy={1836.71}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1051.28}
          cy={1840.24}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1051.45}
          cy={1843.76}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1051.69}
          cy={1847.27}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1052}
          cy={1850.78}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1052.38}
          cy={1854.27}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1052.85}
          cy={1857.76}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1053.38}
          cy={1861.24}
          r={36.54}
        />
        <circle className="front_svg__circle" cx={1054} cy={1864.7} r={36.54} />
        <circle
          className="front_svg__circle"
          cx={1054.69}
          cy={1868.15}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1055.47}
          cy={1871.58}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1056.32}
          cy={1875}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1057.26}
          cy={1878.41}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1058.28}
          cy={1881.79}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1059.39}
          cy={1885.15}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1061.09}
          cy={1889.86}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1063.5}
          cy={1895.79}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1066.15}
          cy={1901.57}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1069.03}
          cy={1907.19}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1072.13}
          cy={1912.66}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1075.44}
          cy={1917.96}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1078.96}
          cy={1923.11}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1082.68}
          cy={1928.1}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1086.6}
          cy={1932.94}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1090.7}
          cy={1937.63}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1094.99}
          cy={1942.16}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1099.44}
          cy={1946.55}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1104.07}
          cy={1950.78}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1108.85}
          cy={1954.86}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1113.79}
          cy={1958.79}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1118.87}
          cy={1962.57}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1124.09}
          cy={1966.2}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1129.44}
          cy={1969.69}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1134.92}
          cy={1973.03}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1140.51}
          cy={1976.22}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1146.22}
          cy={1979.27}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1152.03}
          cy={1982.17}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1157.94}
          cy={1984.94}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1163.94}
          cy={1987.56}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1170.02}
          cy={1990.03}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1176.18}
          cy={1992.37}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1182.41}
          cy={1994.57}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1188.71}
          cy={1996.62}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1195.06}
          cy={1998.54}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1201.45}
          cy={2000.32}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1207.89}
          cy={2001.97}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1214.37}
          cy={2003.47}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1220.87}
          cy={2004.85}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1227.4}
          cy={2006.08}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1233.94}
          cy={2007.19}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1240.49}
          cy={2008.16}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1247.03}
          cy={2009}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1253.58}
          cy={2009.71}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1260.11}
          cy={2010.28}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1266.62}
          cy={2010.73}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1273.1}
          cy={2011.05}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1277.42}
          cy={2011.2}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1281.75}
          cy={2011.3}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1286.08}
          cy={2011.37}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1290.4}
          cy={2011.39}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1294.73}
          cy={2011.37}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1299.05}
          cy={2011.3}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1303.38}
          cy={2011.2}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1307.7}
          cy={2011.05}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1312.02}
          cy={2010.87}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1316.34}
          cy={2010.64}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1320.66}
          cy={2010.37}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1324.97}
          cy={2010.06}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1329.28}
          cy={2009.7}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1333.59}
          cy={2009.31}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1337.89}
          cy={2008.88}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1342.19}
          cy={2008.4}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1346.48}
          cy={2007.89}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1350.77}
          cy={2007.33}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1355.05}
          cy={2006.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1359.33}
          cy={2006.1}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1363.6}
          cy={2005.43}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1367.87}
          cy={2004.71}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1372.13}
          cy={2003.96}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1376.38}
          cy={2003.16}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1380.62}
          cy={2002.33}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1384.86}
          cy={2001.45}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1389.09}
          cy={2000.54}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1393.31}
          cy={1999.59}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1397.52}
          cy={1998.6}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1401.72}
          cy={1997.57}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1405.92}
          cy={1996.51}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1410.1}
          cy={1995.4}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1414.27}
          cy={1994.26}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1418.43}
          cy={1993.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1422.58}
          cy={1991.85}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1426.73}
          cy={1990.59}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1430.85}
          cy={1989.3}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1434.97}
          cy={1987.96}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1439.07}
          cy={1986.59}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1443.17}
          cy={1985.18}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1447.51}
          cy={1983.64}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1452.12}
          cy={1981.96}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1456.7}
          cy={1980.22}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1461.26}
          cy={1978.44}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1465.81}
          cy={1976.62}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1470.34}
          cy={1974.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1474.85}
          cy={1972.82}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1479.33}
          cy={1970.86}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1483.8}
          cy={1968.85}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1488.25}
          cy={1966.79}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1492.67}
          cy={1964.68}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1497.07}
          cy={1962.53}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1501.45}
          cy={1960.34}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1505.81}
          cy={1958.1}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1510.14}
          cy={1955.81}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1514.45}
          cy={1953.48}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1518.73}
          cy={1951.1}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1522.99}
          cy={1948.68}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1527.22}
          cy={1946.22}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1531.43}
          cy={1943.71}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1535.61}
          cy={1941.16}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1539.76}
          cy={1938.56}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1543.89}
          cy={1935.92}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1547.99}
          cy={1933.24}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1552.05}
          cy={1930.51}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1556.09}
          cy={1927.75}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1560.1}
          cy={1924.93}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1564.08}
          cy={1922.08}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1568.03}
          cy={1919.18}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1571.94}
          cy={1916.24}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1575.83}
          cy={1913.26}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1579.68}
          cy={1910.24}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1583.5}
          cy={1907.18}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1587.29}
          cy={1904.07}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1591.04}
          cy={1900.92}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1594.76}
          cy={1897.74}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1598.44}
          cy={1894.51}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1602.09}
          cy={1891.24}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1605.7}
          cy={1887.93}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1609.28}
          cy={1884.58}
          r={36.54}
        />
        <circle
          className="front_svg__circle"
          cx={1612.81}
          cy={1881.19}
          r={36.54}
        />
      </g>
      <path
        id="front_svg__heart"
        fill="red"
        className="front_svg__cls-2434"
        d="M1821.76 1893.9a48.35 48.35 0 00-53.49 44c0 .37-.37.37-.37 0-2.2-26.75-26-47.27-53.49-44-22.36 2.56-40.68 20.89-42.51 43.6a48.61 48.61 0 0017.22 41.77l5.87 5.13 73.28 64.86 73.65-64.86c5.86-5.49 3.66-3.66 5.49-5.13a48.44 48.44 0 00-25.65-85.37z"
      />
      <g id="front_svg__hand">
        <path
          className="front_svg__cls-2435"
          d="M214.43 1888.09l-1.68-2.88c-5.28-9-16.33-12.42-24.68-7.55l-36.68 21.42c.84-17.91-.71-40.15-10.26-55.86-2.63-4.32-6.16-8.4-10.73-10.14-8.08-3.08-16.7 2.3-20.72 9.7s-4.68 16.36-6 24.91c-4.22 28.53-15.85 55.81-33.84 76.93l61.24 109.57 62.09-36.25 5.13-3 15.43-9 36.68-21.42c8.35-4.87 10.84-16.15 5.56-25.19l-1.68-2.88c-5.28-9-16.32-12.42-24.67-7.55 8.35-4.87 10.83-16.15 5.56-25.19l-1.68-2.88c-5.28-9-16.33-12.42-24.68-7.55 8.4-4.87 10.89-16.15 5.61-25.19z"
        />
        <path
          stroke="#231F20"
          strokeWidth={3.15}
          className="front_svg__cls-2436"
          d="M211.74 1911.97l-54.82 32M232.06 1946.77l-54.82 32M152.74 1898.29l-16.77 9.8"
        />
        <path
          className="front_svg__cls-2437"
          fill="#FFFF39"
          stroke="#231F20"
          strokeWidth={3.15}
          d="M34.177 1965.068l37.703-22.015 63.613 108.948-37.703 22.015z"
        />
        <circle cx={63.97} cy={1972.96} r={8.89} />
      </g>
      <g id="front_svg__pen">
        <path
          className="front_svg__cls-2435"
          d="M517.42 1326.67c-4.85 26.36-60 32.5-73.72 53.68-14.23 22 2.1 74.69-19.08 89.24s-64.51-19.56-90.05-14.22c-24.74 5.17-50.12 54.48-76.64 49.63-26.35-4.85-32.49-60-53.67-73.72-22-14.23-74.7 2.1-89.25-19.08s19.57-64.51 14.23-90c-5.17-24.74-54.48-50.12-49.63-76.64s60-32.5 73.72-53.67c14.23-22-2.1-74.7 19.08-89.25s64.51 19.56 90 14.23c24.74-5.18 50.12-54.49 76.63-49.64s32.5 60 53.68 73.73c22 14.23 74.69-2.1 89.24 19.08s-19.56 64.5-14.22 90c5.38 24.73 54.53 50.28 49.68 76.63z"
        />
        <path
          fill="red"
          className="front_svg__cls-2434"
          d="M493 1322.15c-4.37 23.44-53.35 28.94-65.48 47.69-12.61 19.56 1.94 66.29-17 79.22s-57.39-17.46-80-12.61c-22 4.69-44.63 48.34-68.07 44s-28.94-53.35-47.69-65.47c-19.57-12.61-66.29 1.94-79.22-17s17.46-57.39 12.61-80c-4.69-22-48.34-44.62-44-68.06s53.35-28.94 65.48-47.7c12.61-19.56-1.94-66.28 17-79.22s57.39 17.46 80 12.61c22-4.69 44.63-48.34 68.07-44s28.94 53.35 47.69 65.48c19.57 12.61 66.29-1.94 79.22 17s-17.46 57.4-12.61 80c4.56 21.98 48.37 44.61 44 68.06z"
        />
        <path
          className="front_svg__cls-4870"
          d="M482 1160c14.56 21.17-19.56 64.5-14.22 90"
        />
        <path
          d="M456.15 1315.35C452.59 1334.27 413 1338.8 403 1354c-10.35 15.84 1.61 53.67-13.75 64.18s-46.4-14.07-64.83-10.19c-17.78 3.72-36.21 39.29-55.13 35.73s-23.44-43.16-38.64-53.19c-15.84-10.34-53.68 1.62-64.18-13.74s14.06-46.4 10.18-64.83c-3.72-17.78-39.29-36.22-35.73-55.13s43.17-23.44 53.19-38.64c10.35-15.85-1.61-53.68 13.74-64.19s46.41 14.07 64.84 10.19c17.78-3.72 36.21-39.29 55.13-35.73s23.44 43.17 38.64 53.19c15.84 10.35 53.67-1.62 64.18 13.74s-14.06 46.4-10.18 64.83c3.84 17.78 39.24 36.06 35.69 55.13z"
          fill="#4bc2f0"
          strokeWidth={3.15}
          stroke="#000"
        />
        <circle
          className="front_svg__cls-4872"
          stroke="#000"
          cx={298.51}
          cy={1286.09}
          r={132.41}
        />
        <circle
          className="front_svg__cls-4872"
          stroke="#000"
          cx={298.51}
          cy={1286.09}
          r={96.84}
        />
        <path
          stroke="#000"
          d="M179.68 1344.29a132 132 0 0094.58 71.79c59.66 11.15 117.54-19.89 142.92-71.79z"
          fill="#ff85ff"
          strokeWidth={3.15}
          strokeMiterlimit={10}
        />
        <path
          className="front_svg__cls-4870"
          d="M297.22 1359a115.52 115.52 0 00-51.9 12.61c-3.23 1.78-6.63 3.72-7.76 6.63-1.45 3.39.49 7.27 3.88 9.7s8.25 3.88 12.94 4.69c10.34 1.77 21.18 1.13 31.69 0 10.5-1 21-2.43 31.68-2.11 10.51.33 21.51 2.59 29.11 7.93a23.55 23.55 0 016.79 7.11"
        />
        <path
          className="front_svg__cls-4874"
          d="M312.26 1245.51h-30.07c-14.56 22-34.28 30.56-34.28 30.56s49.31 21.5 49.31 82.94c0-61.44 49.31-82.94 49.31-82.94s-19.72-8.57-34.27-30.56z"
        />
        <path className="front_svg__cls-4870" d="M297.38 1356.26v-78.09" />
        <path
          className="front_svg__cls-4874"
          d="M328.42 1203.31v-46.07c-1.94-.49-3.71-.81-5.65-1.13a131.13 131.13 0 00-55.62 1.61v45.59c0 16.5 13.74 29.91 30.72 29.91 16.81-.16 30.55-13.41 30.55-29.91z"
        />
        <path
          className="front_svg__cls-4874"
          d="M265.86 1233.06h62.57v12.45h-62.57z"
        />
        <path className="front_svg__cls-4870" d="M266.99 1189.9h61.43" />
      </g>
      <g id="front_svg__note">
        <path
          className="front_svg__cls-2435"
          d="M1474.1 1704.2c0-49.43 18-49.43 18-99.16 0-49.43-18-49.43-18-99.17 0-16.37 3.15-25.81 6.93-34.31h231.38c-3.78 8.5-6.92 17.94-6.92 34.31 0 49.43 17.94 49.43 17.94 99.17 0 49.42-17.94 49.42-17.94 99.16z"
        />
        <path
          className="front_svg__cls-4872"
          fill="#C581FF"
          stroke="#000"
          d="M1474.42 1516.26h231.38c-.31-3.15-.31-6.61-.31-10.07 0-16.37 3.14-25.82 6.92-34.32H1481c-3.78 8.5-6.93 18-6.93 34.32a99.51 99.51 0 00.35 10.07z"
        />
        <circle
          stroke="#000"
          strokeWidth={4}
          fill="#fff"
          cx={1535.18}
          cy={1556.24}
          r={10.7}
        />
        <circle
          stroke="#000"
          strokeWidth={4}
          fill="#fff"
          cx={1524.47}
          cy={1662.01}
          r={10.7}
        />
        <circle cx={1529.83} cy={1606.61} r={10.7} />
        <path
          className="front_svg__cls-4870"
          d="M1576.1 1556.24h111.13M1565.71 1606.61h111.44M1568.55 1657.29h111.44"
        />
      </g>
      <g id="front_svg__shooting-star">
        <path
          stroke="#231F20"
          strokeWidth={3.15}
          d="M1736.69 138c-24.63-80.3-75.16-152.25-142-201.93s-149.26-77.1-231.92-76.88v106.67c135.56-5.78 270.9 73 333 193.59"
          strokeMiterlimit={10}
          fill="#fff"
        />
        <path
          stroke="#231F20"
          strokeWidth={3.15}
          className="front_svg__cls-4878"
          d="M1362.79-73.11s270.47 27.19 341.35 219.71M1362.79-111.66s256.55 7.92 357.2 241.56"
        />
        <path
          fill="#FFFF39"
          stroke="#231F20"
          strokeWidth={3.15}
          className="front_svg__cls-2437"
          d="M1746.76 36.96l35.97 110.28h115.85l-93.79 68.1 35.76 110.28-93.79-68.09-93.8 68.09 35.76-110.28-93.79-68.1h116.06l35.77-110.28z"
        />
        <ellipse
          stroke="#231F20"
          strokeWidth={3.15}
          className="front_svg__cls-4879"
          cx={1729.84}
          cy={174.65}
          rx={6.85}
          ry={15.42}
        />
        <ellipse
          stroke="#231F20"
          strokeWidth={3.15}
          className="front_svg__cls-4879"
          cx={1763.67}
          cy={174.65}
          rx={6.85}
          ry={15.42}
        />
        <circle cx={1746.76} cy={200.78} r={10.06} />
        <path
          stroke="#231F20"
          strokeWidth={3.15}
          className="front_svg__cls-4878"
          d="M1729.62 216.2a17.77 17.77 0 0034.27 0"
        />
      </g>
      <g id="front_svg__batterie">
        <path
          id="front_svg__Path"
          className="front_svg__cls-4880"
          d="M1519.44 186.95h17.31v47.49l-8.65 12.96-9.84-13.84-8.81-32.93 9.99-13.68z"
        />
        <path
          id="front_svg__Shape"
          className="front_svg__cls-4881"
          d="M1520.1 188.24l-9.23 12.65 8.58 32.11 8.61 12.11 7.39-11.06v-45.81zm16.65 46.2l-8.65 13-9.84-13.84-8.81-32.93 10-13.68h17.31z"
        />
        <path
          id="front_svg__Path-2"
          data-name="Path"
          className="front_svg__cls-4880"
          d="M1509.45 200.6h19.5v46.8h-19.5v-46.8z"
        />
        <path
          id="front_svg__Path-Copy-10"
          d="M1529.6 200h-20.8v48.1h20.8zm-1.3 1.3v45.5h-18.2v-45.5z"
        />
        <path
          id="front_svg__Path-3"
          data-name="Path"
          className="front_svg__cls-4881"
          d="M1537.4 187.6l-8.59 14.3-1.16-.66 8.59-14.29 1.16.65z"
        />
        <path
          id="front_svg__Shape-Copy-3"
          d="M1443.6 175.68a20.65 20.65 0 0114.69 5.88l.26.25a19.58 19.58 0 016.29 14.69 19.89 19.89 0 01-6.29 14.93 21 21 0 01-15.07 5.89 20.62 20.62 0 01-15-6 19.9 19.9 0 01-6.17-14.8 19.54 19.54 0 016-14.44l.25-.24a20.67 20.67 0 0115.04-6.16zm0 1.3a19.29 19.29 0 00-13.79 5.53l-.26.24a18.31 18.31 0 00-5.89 13.75 18.59 18.59 0 005.78 13.87 19.3 19.3 0 0014 5.65 19.71 19.71 0 0014.17-5.53 18.59 18.59 0 005.89-14 18.29 18.29 0 00-5.9-13.75 19.34 19.34 0 00-14-5.74zm-8.26-41.4h17.31l-56.34 80.16h-17.19zm14.81 1.3H1436l-54.4 77.56h14zm-6.55 51.19a7.54 7.54 0 015.71 2.39 8.45 8.45 0 012.25 6 9 9 0 01-2.25 6.28 7.54 7.54 0 01-5.71 2.39 7.7 7.7 0 01-5.83-2.39 8.79 8.79 0 01-2.25-6.28 8.45 8.45 0 012.26-6.05 8 8 0 015.82-2.34zm0 1.3a6.66 6.66 0 00-4.89 2 7.19 7.19 0 00-1.89 5.15 7.48 7.48 0 001.89 5.38 6.4 6.4 0 004.89 2 6.27 6.27 0 004.76-2 7.78 7.78 0 001.9-5.4 7.19 7.19 0 00-1.89-5.15 6.28 6.28 0 00-4.77-1.98zm-55.67-55.25a20.66 20.66 0 0114.94 6.13 19.59 19.59 0 016.3 14.69 19.86 19.86 0 01-6.3 14.93 21 21 0 01-15.06 5.89 20.64 20.64 0 01-15-6 19.91 19.91 0 01-6.16-14.8 19.54 19.54 0 016-14.44l.25-.24a20.65 20.65 0 0115.03-6.16zm0 1.3a19.36 19.36 0 00-13.8 5.53l-.25.24a18.31 18.31 0 00-5.89 13.75 18.6 18.6 0 005.77 13.87 19.34 19.34 0 0014 5.65 19.67 19.67 0 0014.16-5.53 18.53 18.53 0 005.9-14 18.26 18.26 0 00-5.66-13.52l-.24-.23a19.38 19.38 0 00-13.99-5.76zm0 11.09a7.55 7.55 0 015.71 2.39 8.46 8.46 0 012.25 6 9.08 9.08 0 01-2.25 6.28 7.55 7.55 0 01-5.71 2.39 7.68 7.68 0 01-5.83-2.39 8.75 8.75 0 01-2.25-6.28 8.47 8.47 0 012.26-6.05 7.94 7.94 0 015.82-2.34zm0 1.3a6.63 6.63 0 00-4.89 2 7.15 7.15 0 00-1.89 5.14 7.51 7.51 0 001.89 5.39 6.41 6.41 0 004.89 2 6.25 6.25 0 004.75-2 7.77 7.77 0 001.91-5.4 7.11 7.11 0 00-1.9-5.14 6.24 6.24 0 00-4.76-1.99z"
        />
        <path
          id="front_svg__Shape-Copy-2"
          d="M1327 134.12c12.23 0 21.41 4.59 27.46 13.76q7.05 10.62 7 28.16t-7.06 28.17c-6.18 9.17-15.4 13.79-27.4 13.79s-21.12-4.59-27.34-13.77q-7.07-10.6-7.05-28.16t7.05-28.15c6.03-9.21 15.17-13.8 27.34-13.8zm0 1.3c-11.73 0-20.45 4.39-26.26 13.18q-6.83 10.28-6.83 27.44t6.83 27.44c6 8.8 14.7 13.19 26.26 13.19s20.41-4.39 26.38-13.19q6.83-10.26 6.83-27.44t-6.84-27.44q-8.72-13.18-26.37-13.18zm0 15.57c5.52 0 9.6 2.57 12.15 7.65q3.12 6.23 3.11 17.4t-3.11 17.41c-2.55 5.08-6.63 7.64-12.15 7.64s-9.61-2.56-12.16-7.65q-3-6.34-3-17.4t3-17.4c2.53-5.08 6.61-7.64 12.16-7.64zm0 1.3c-5 0-8.66 2.29-11 6.91q-2.87 6-2.87 16.84t2.86 16.83c2.33 4.64 6 6.92 11 6.92s8.66-2.28 11-6.92q3-5.91 3-16.83t-3-16.82c-2.35-4.64-5.99-6.93-10.99-6.93z"
        />
        <path
          id="front_svg__Shape-2"
          data-name="Shape"
          className="front_svg__cls-4881"
          d="M1133.42 184.17l-26 38.7L1136 329.71l380.73 39 26.12-38.18V184.17zm410.72 146.74l-26.78 39.16L1135 330.91l-29-108.28 26.69-39.76h411.41z"
        />
        <path
          id="front_svg__Path-4"
          data-name="Path"
          className="front_svg__cls-4882"
          d="M1132.73 182.87h411.41v148.04l-26.78 39.16-382.4-39.16-28.92-108.28 26.69-39.76z"
        />
        <path
          id="front_svg__Path-5"
          data-name="Path"
          className="front_svg__cls-4880"
          d="M1106.04 222.52h409.5v148.2h-409.5v-148.2z"
        />
        <path
          id="front_svg__Path-6"
          data-name="Path"
          fill="url(#front_svg__linear-gradient-4865)"
          d="M1118.38 236.82h382.91v119.6h-382.91v-119.6z"
        />
        <path
          id="front_svg__Path-Copy-15"
          className="front_svg__cls-4884"
          d="M1516.84 222.52H1106V372h410.8zm-1.3 1.3v146.9h-408.2v-146.9z"
        />
        <path
          id="front_svg__Path-7"
          data-name="Path"
          className="front_svg__cls-4885"
          d="M1458.34 102.27l-22.1 32.5-.65 3.25 14.3-.65 24.7-35.1h-16.25z"
        />
        <path
          id="front_svg__Path-Copy-13"
          d="M1475.84 101.62H1458l-22.37 32.89-.84 4.2 15.45-.71zm-2.5 1.3l-23.8 33.81-13.15.6.46-2.31 21.83-32.1z"
        />
        <path
          id="front_svg__Path-Copy"
          d="M1502.54 236.17h-384.15v120.9h384.15zm-1.3 1.3v118.3h-381.55v-118.3z"
        />
        <path
          id="front_svg__Path-Copy-2"
          d="M1213.24 236.17h-49.4v120.9h49.4zm-1.3 1.3v118.3h-46.8v-118.3z"
        />
        <path
          id="front_svg__Path-Copy-3"
          d="M1264 236.17h-52v120.9h52zm-1.3 1.3v118.3h-49.4v-118.3z"
        />
        <path
          id="front_svg__Path-Copy-5"
          d="M1358.89 236.17h-50.7v120.9h50.7zm-1.3 1.3v118.3h-48.1v-118.3z"
        />
        <path
          id="front_svg__Path-Copy-6"
          d="M1407.06 236.17h-49.4v120.9h49.4zm-1.3 1.3v118.3H1359v-118.3z"
        />
        <path
          id="front_svg__Path-Copy-8"
          d="M1502.54 236.17h-49.4v120.9h49.4zm-1.3 1.3v118.3h-46.8v-118.3z"
        />
        <path
          id="front_svg__Path-8"
          data-name="Path"
          className="front_svg__cls-4884"
          d="M1542.3 183.81l1.08.73-26.65 39-1.08-.74 26.65-38.99z"
        />
        <path
          id="front_svg__Path-9"
          data-name="Path"
          className="front_svg__cls-4882"
          d="M1535.09 217.32h33.79v92.95l-16.9 25.35-19.21-27.09-17.18-64.44 19.5-26.77z"
        />
        <path
          id="front_svg__Shape-3"
          data-name="Shape"
          className="front_svg__cls-4881"
          d="M1536.33 218.62l-18.75 25.73 17 63.62 18 25.36 15.64-23.46v-91.25zm33.14 91.65l-16.9 25.35-19.22-27.09-17.18-64.44 19.5-26.77h33.8z"
        />
        <path
          id="front_svg__Path-10"
          data-name="Path"
          className="front_svg__cls-4880"
          d="M1516.17 244.62h37.7v91h-37.7v-91z"
        />
        <path
          id="front_svg__Path-Copy-9"
          className="front_svg__cls-4884"
          d="M1554.52 244h-39v92.3h39zm-1.3 1.3V335h-36.4v-89.7z"
        />
        <path
          id="front_svg__Path-11"
          data-name="Path"
          className="front_svg__cls-4885"
          d="M1450.66 150.63l-26.12 37.29 10.45 19 24.16 3.93 27.42-41.85c1.09-4.8.39-16.09-11.1-22.9s-21.33.17-24.81 4.53z"
        />
        <path
          id="front_svg__Path-Copy-14"
          d="M1459.86 143.54a21.63 21.63 0 00-9.71 6.69l-26.37 37.65 10.79 19.6 24.89 4.05 27.72-42.32v-.12a21.18 21.18 0 00-.86-11.05 23.23 23.23 0 00-10.55-12.54 18.64 18.64 0 00-15.91-1.96zm15.28 3.07a22 22 0 0110 11.86l.11.34a20 20 0 01.76 9.73v.16l-27.12 41.41-23.44-3.81-10.15-18.3 25.89-37a20.38 20.38 0 019.08-6.24 17.37 17.37 0 0114.87 1.85z"
        />
        <path
          id="front_svg__Path-12"
          data-name="Path"
          className="front_svg__cls-4885"
          d="M1186 118.83l-22.13 31.31 1.3 5.22h24.74v43l12.37 16.31 16.92-23.49 14.34 11.82 39.71 5.87 20.18-26.1 22.13 22.84h37.1l25.39-35.23h23.43l28-38.49c2.82-6.3 5.21-20.61-7.81-27.39s-22.78-.66-26 3.26l-15 18.26c-.22-5.22-4.56-17.09-20.18-22.83s-29.07 1.09-33.85 5.22l-20.83 26.09c2-11.74-9.76-30.66-28.64-32.61-15.1-1.57-25.38 5.43-28.64 9.13l-24.73 35.22.65-42.4h-17.58l-7.87 11.07c-3.6 3.66-10.16 4.09-13 3.92z"
        />
        <path
          id="front_svg__Path-Copy-12"
          d="M1338.67 102.1a33.48 33.48 0 00-13.12 6.45l-.08.08L1306 133v-.23c.1-5.66-2.4-12.35-6.85-18a33.12 33.12 0 00-22.58-12.88 39 39 0 00-19.08 2.64 28.55 28.55 0 00-10.12 6.71v.06l-23.52 33.49.63-41h-18.58l-8 11.32c-2.85 2.85-8.21 4.06-12.51 3.73h-.37l-22.51 31.86 1.49 6h24.6v42.62l13 17.18 17-23.63 13.93 11.41 40.26 6 19.95-25.8 21.8 22.49h37.71l25.39-35.23h23.43l28.19-38.75.06-.12a27 27 0 002.09-13.87 18.19 18.19 0 00-10.19-14.37c-6.06-3.16-11.87-3.82-17.15-2.43l-.33.09a19.15 19.15 0 00-9.36 5.76l-14 17.06v-.14a24.66 24.66 0 00-4.25-9.83c-3.58-5.07-9-9.2-16.17-11.85a35.64 35.64 0 00-21.29-1.19zm20.93 2.33c7 2.56 12.13 6.52 15.56 11.38a21.75 21.75 0 014.19 10.87l.07 1.7 16-19.58a18 18 0 019-5.43c5-1.3 10.45-.68 16.22 2.33a16.92 16.92 0 019.5 13.39v.38a25.79 25.79 0 01-1.89 12.46l-.12.27-27.75 38.16h-23.44l-25.38 35.23h-36.5l-22.46-23.18-20.4 26.39-39.04-5.8-14.71-12.07-16.82 23.34-11.7-15.44v-43.47h-24.88l-1.11-4.44 21.75-30.77h.19c4.53.22 9.93-1.09 13-4.14l.07-.08 7.62-10.82h16.58l-.68 43.86 25.93-36.93a27.26 27.26 0 019.64-6.37 37.62 37.62 0 0118.45-2.55 31.83 31.83 0 0121.68 12.4c4.91 6.26 7.33 13.75 6.38 19.47l-.41 2.46 22.35-28a32.28 32.28 0 0112.59-6.17 34.37 34.37 0 0120.52 1.15z"
        />
        <path
          id="front_svg__Path-13"
          data-name="Path"
          className="front_svg__cls-4886"
          d="M1201.59 214.72h-19v-51.56h-18.73v-12.83q8.58-.14 14.38-4.4t7-10.51h16.31z"
        />
        <path
          id="front_svg__Path-Copy-11"
          d="M1202.24 135.42h-17.51l-.09.54c-.7 4-2.94 7.33-6.75 10.09a23.55 23.55 0 01-14 4.28h-.64v14.12H1182V216h20.27zm-1.3 1.3v78h-17.67v-51.56h-18.73v-11.55h.19a24.33 24.33 0 0013.92-4.5l.28-.2a17 17 0 006.81-9.83l.07-.35z"
        />
        <path
          stroke="#000"
          strokeWidth={1.75}
          id="front_svg__Shape-Copy"
          d="M1250.28 134.12c12.23 0 21.41 4.59 27.46 13.76q7.07 10.62 7 28.16t-7 28.17q-9.33 13.79-27.46 13.79t-27.34-13.77q-7.05-10.6-7-28.16t7-28.15c6.06-9.21 15.19-13.8 27.34-13.8zm0 1.3c-11.73 0-20.45 4.39-26.26 13.18q-6.82 10.28-6.83 27.44t6.83 27.44c6 8.8 14.7 13.19 26.26 13.19s20.41-4.39 26.38-13.19q6.83-10.26 6.83-27.44t-6.83-27.44c-5.81-8.79-14.57-13.18-26.38-13.18zm0 15.57c5.53 0 9.61 2.57 12.15 7.65q3.12 6.23 3.12 17.4t-3.12 17.41c-2.54 5.08-6.62 7.64-12.15 7.64s-9.61-2.56-12.16-7.65q-3-6.34-3-17.4t3-17.4c2.55-5.08 6.63-7.64 12.16-7.64zm0 1.3c-5 0-8.66 2.29-11 6.91q-2.86 6-2.87 16.84t2.86 16.83c2.33 4.64 6 6.92 11 6.92s8.66-2.28 11-6.92q3-5.91 3-16.83t-3-16.82c-2.33-4.64-5.96-6.93-10.99-6.93z"
        />
        <path
          stroke="#000"
          strokeWidth={1.75}
          id="front_svg__Shape-4"
          data-name="Shape"
          className="front_svg__cls-4886"
          d="M1315.41 158.28q-2.92 6.18-2.93 17.11t2.93 17.12q3.64 7.29 11.57 7.28t11.57-7.28q3-6.07 3-17.12t-3-17.11Q1334.89 151 1327 151t-11.59 7.28zm-15.23 44.91q-6.95-10.44-6.94-27.8t6.94-27.8q8.89-13.47 26.8-13.47t26.92 13.47q6.93 10.44 6.94 27.8t-6.94 27.8q-9.14 13.49-26.92 13.48t-26.8-13.48z"
        />
        <path
          stroke="#000"
          strokeWidth={1.75}
          id="front_svg__Shape-5"
          data-name="Shape"
          className="front_svg__cls-4886"
          d="M1380.5 154.29a8.13 8.13 0 002.07 5.83 7 7 0 005.36 2.19 6.91 6.91 0 005.24-2.19 8.4 8.4 0 002.07-5.83 7.81 7.81 0 00-2.07-5.59 6.91 6.91 0 00-5.24-2.19 7.3 7.3 0 00-5.36 2.19 7.81 7.81 0 00-2.07 5.59zm-13.16 0a19 19 0 016.09-14.22 20.63 20.63 0 0129 0 18.92 18.92 0 016.1 14.22 19.19 19.19 0 01-6.1 14.46 20.33 20.33 0 01-14.61 5.71 20 20 0 01-14.5-5.83 19.27 19.27 0 01-5.98-14.34zm68.83 41.56a8.13 8.13 0 002.07 5.83 7 7 0 005.36 2.19 6.91 6.91 0 005.24-2.19 8.4 8.4 0 002.07-5.83 7.81 7.81 0 00-2.07-5.59 6.91 6.91 0 00-5.24-2.19 7.3 7.3 0 00-5.36 2.19 7.81 7.81 0 00-2.07 5.59zm-13.16 0a19 19 0 016.09-14.22 20.64 20.64 0 0129 0 19 19 0 016.09 14.22 19.22 19.22 0 01-6.09 14.46 20.34 20.34 0 01-14.62 5.71 20 20 0 01-14.5-5.83 19.27 19.27 0 01-5.98-14.34zm-27 18.59h-15.6l55.31-78.86h15.72z"
        />
        <path
          id="front_svg__Path-14"
          data-name="Path"
          d="M1206.79 103.57l1.07.74-22.1 31.85-1.07-.74 22.1-31.85z"
        />
        <path
          id="front_svg__Shape-6"
          data-name="Shape"
          className="front_svg__cls-4886"
          d="M1238.71 158.28q-2.93 6.18-2.93 17.11t2.93 17.12q3.64 7.29 11.57 7.28t11.57-7.28q3-6.07 3.05-17.12t-3.05-17.11q-3.66-7.29-11.57-7.29t-11.57 7.29zm-15.23 44.91q-6.95-10.44-6.94-27.8t6.94-27.8q8.89-13.47 26.8-13.47t26.92 13.47q6.94 10.44 6.94 27.8t-6.94 27.8q-9.14 13.49-26.92 13.48t-26.8-13.48z"
        />
      </g>
    </svg>
  );
})

export default SvgFront;

